export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B %Y',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Niedziela',
      'Poniedziałek',
      'Wtorek',
      'Środa',
      'Czwartek',
      'Piątek',
      'Sobota',
    ],
    abbr_day_names: ['Niedz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.'],
    month_names: [
      null,
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    abbr_month_names: [
      null,
      'Sty',
      'Lut',
      'Mar',
      'Kwi',
      'Maj',
      'Cze',
      'Lip',
      'Sie',
      'Wrz',
      'Paź',
      'Lis',
      'Gru',
    ],
    order: [':rok', ':miesiąc', ':dzień'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: null,
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: null,
      },
    },
    human: {
      format: {
        delimiter: null,
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: 'B',
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: null,
          thousand: 'Tysiąc',
          million: 'Milion',
          billion: 'Miliard',
          trillion: 'Bilion',
          quadrillion: 'Biliard',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'pół minuty',
      less_than_x_seconds: {
        one: 'mniej niż 1 sekunda',
        other: 'mniej niż %{count} s',
        few: 'mniej niż %{count} s',
        many: 'mniej niż %{count} s',
      },
      x_seconds: {
        one: '1 sekunda',
        other: '%{count} s',
        few: '%{count} s',
        many: '%{count} s',
      },
      less_than_x_minutes: {
        one: 'mniej niż 1 minuta',
        other: 'mniej niż %{count} min',
        few: 'mniej niż %{count} min',
        many: 'mniej niż %{count} min',
      },
      x_minutes: {
        one: '1 minuta',
        other: '%{count} min',
        few: '%{count} min',
        many: '%{count} min',
      },
      about_x_hours: {
        one: 'około 1 godziny',
        other: 'około %{count} godz.',
        few: 'około %{count} godz.',
        many: 'około %{count} godz.',
      },
      x_days: {
        one: '1 dzień',
        other: '%{count} dni',
        few: '%{count} dni',
        many: '%{count} dni',
      },
      about_x_months: {
        one: 'około 1 miesiąca',
        other: 'około %{count} mies.',
        few: 'około %{count} mies.',
        many: 'około %{count} mies.',
      },
      x_months: {
        one: '1 miesiąc',
        other: '%{count} mies.',
        few: '%{count} mies.',
        many: '%{count} mies.',
      },
      about_x_years: {
        one: 'około 1 roku',
        other: 'około %{count} lat',
        few: 'około %{count} lat',
        many: 'około %{count} lat',
      },
      over_x_years: {
        one: 'ponad 1 rok',
        other: 'ponad %{count} lat(a)',
        few: 'ponad %{count} lat(a)',
        many: 'ponad %{count} lat(a)',
      },
      almost_x_years: {
        one: 'prawie 1 rok',
        other: 'prawie %{count} lat(a)',
        few: 'prawie %{count} lat(a)',
        many: 'prawie %{count} lat(a)',
      },
      x_years: {
        one: '1 year',
        other: '%{count} years',
      },
      x_weeks: {
        one: '1 tydzień',
        other: '%{count} tyg.',
        few: '%{count} tyg.',
        many: '%{count} tyg.',
      },
      x_hours: {
        one: '1 godz.',
        other: '%{count} godz.',
      },
    },
    prompts: {
      year: 'rok',
      month: 'miesiąc',
      day: 'dzień',
      hour: 'godz.',
      minute: 'min',
      second: 's',
    },
  },
  page: {
    plus: {
      button: {
        text: 'Ulepsz do wersji Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Maksymalnie pięć różnych obrazów',
        best_2: 'w formacie JPEG lub PNG',
        best_3: 'Do %{size}',
        best_4: '%{resolution} pikseli lub więcej',
        best_5: 'Nie mogą to być pliki GIF ani filmy (niestety)',
        best_title: 'Ważne:',
        text: 'Wyeksponuj swoją firmę lub markę, dodając maksymalnie pięć filmów lub obrazów wyświetlanych rotacyjnie:',
        best_five: 'Rozdzielczość filmów %{videoResolution}',
        best_four: 'Rozdzielczość obrazów %{resolution}',
        best_one: 'Do pięciu filmów lub obrazów',
        best_six:
          'Rotacja tapet w przypadku obrazów następuje co %{rotationInterval} s, natomiast filmy dłuższe niż %{rotationInterval} s ulegną skróceniu',
        best_three: 'Maksymalnie %{size} na film/obraz',
        best_two: 'Pliki JPEG, PNG lub MP4',
        notice:
          "Uwaga, uwaga – tapety wylądowały! <a href='/profile'>Ustaw teraz film jako swoje tło</a>.",
      },
      upsell: {
        benefit_one_alt: 'Uzyskaj własną stronę WeTransfer',
        heading_alt: 'Dostarczaj efekty swojej pracy w doskonałym stylu',
        benefit_one: 'Uzyskaj własną domenę WeTransfer',
        benefit_three: 'Zaprojektuj swoje wiadomości e-mail z transferem',
        benefit_two:
          'Wyświetlaj niestandardowe tapety, gdy użytkownicy pobierają Twoje pliki',
        button: {
          action: 'Więcej informacji',
        },
        heading: 'Pochwal się swoją marką dzięki WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send the best.</strong> Make a great impression every time people download your files.<br /> <strong>Receive with ease.</strong> Anyone can upload files to you as part of your plan.',
        protip: {
          text: '<strong>Pro tip:</strong> Requesting a transfer from someone? Share a special link to pre-fill the description for them.',
          link: 'Learn more',
        },
      },
      pagename: 'Branding',
      'onboarding-step-two':
        "Zaprezentuj swoje pliki w doskonałym stylu, spersonalizuj swoją stronę WeTransfer i napawaj się jej nowym wyglądem na <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Dostosuj swoje adresy e-mail',
      sent_you_files: 'wysyła Ci kilka plików',
      email_background_instruction_with_spec:
        'Dodaj obraz, aby wyróżnić swoje wiadomości e-mail z transferami. Aby uzyskać najlepszy wygląd, obrazy powinny mieć rozmiar %{resolution} pikseli (ewentualnie zostaną przycięte, aby je dopasować). Maksymalna wielkość pliku to %{size}.',
      receiving: 'Adres e-mail profilu',
      choose_wallpapers: 'Dodaj własne tapety',
      'step-one-banner':
        'Aby rozpocząć, wybierz adres URL swojej strony WeTransfer. Zawsze możesz to później zmienić.',
      description: {
        pro: 'Twoja strona WeTransfer pozwala Ci zrobić doskonałe wrażenie za każdym razem, gdy ktoś pobiera wysłane przez Ciebie pliki. Każdy może tutaj również wysłać Ci do 200 GB danych w ramach planu WeTransfer Pro.',
        premium:
          'Dzięki własnej stronie WeTransfer możesz zrobić doskonałe wrażenie na wszystkich, którzy pobierają Twoje pliki. Na tej stronie każdy może również wysłać Ci pliki bez ograniczeń wielkości w ramach planu WeTransfer Premium.',
      },
      'instructions-1': 'Zmień nazwę i adres URL tyle razy, ile potrzebujesz.',
      'instructions-2':
        'Strona zostanie zaktualizowana natychmiast po ustawieniu nowego adresu URL.',
      title: 'Edytowanie strony',
      profile_url: 'Adres URL',
    },
    payment: {
      never_actived_retry:
        'Twoje konto nie jest jeszcze aktywne. Ukończ rejestrację, aby rozpocząć korzystanie z planu <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plan i płatność',
      autorenew_heading: 'Dane dotyczące płatności',
      autorenew_notice:
        'Twoja subskrypcja Pro %{planName} (%{deal}) zostanie odnowiona automatycznie %{autorenewal_attempt}.',
      will_expire_notice:
        "Twoja subskrypcja Pro <span class='payment__notice'>wygaśnie za %{daysBetween} dni</span>. Odnów swoje konto teraz lub skonfiguruj automatyczne odnawianie.",
      never_actived_notice:
        'Twoje konto nie jest jeszcze aktywne. <a href="/payment/retry">Ukończ rejestrację, aby rozpocząć korzystanie z planu Pro.</a>',
      manual_renewal_expiry_notice: 'Twoje konto Pro wygaśnie %{expiry}.',
      to_checkout: 'Przejdź do kasy',
      updating: 'Aktualizacja...',
      yes_disable: 'Tak, proszę',
      review_billing_link: 'Zaktualizować metodę płatności?',
      autorenew_failed:
        "Twoja subskrypcja Pro %{deal}/%{period} wygaśnie <span class='payment__notice'><strong> za %{daysBetween} dni</strong>. Nie można odnowić Twojego konta – należy ręcznie odnowić konto przed <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Czy na pewno chcesz zatrzymać automatyczne odnawianie?',
      disable_autorenewal: 'Zatrzymaj automatyczne odnawianie',
      enable_autorenewal: 'Włącz automatyczne odnawianie',
      renew_now: 'Odnów teraz',
      subscription_expired: 'Twoja subskrypcja Pro dobiegła końca.',
      cancel_heading: 'Czas na coś nowego?',
      cancel_info:
        'Rozumiemy, takie rzeczy się zdarzają. Po anulowaniu subskrypcji będziemy przechowywać Twoje pliki przez kolejne 30 dni (ale nie pod poduszką, bez dziwactw) na wypadek, gdyby zdarzyło Ci się o czymś zapomnieć. Możesz również wznowić subskrypcję, kiedy tylko zechcesz.',
      cancel_info_subscription:
        'Rozumiemy, takie rzeczy się zdarzają. W przypadku anulowania subskrypcji możesz nadal korzystać z konta Pro do %{subscriptionExpiryDate}. Po tym terminie będziemy przechowywać Twoje pliki przez kolejne 30 dni (ale nie pod poduszką, bez dziwactw) na wypadek, gdyby zdarzyło Ci się o czymś zapomnieć. Możesz również wznowić subskrypcję, kiedy tylko zechcesz.',
      cancel_now: 'Anuluj subskrypcję',
      cancelling: 'Anulowanie...',
      confirm_cancel_subscription: 'Czy na pewno chcesz anulować subskrypcję?',
      confirm_reactivate_subscription:
        'Doskonały wybór! Jeszcze tylko jedno kliknięcie, aby reaktywować metodę płatności',
      manual_renewal_in_future_notice:
        'Twoja subskrypcja Pro za %{deal}/%{period} wygaśnie za %{daysBetween} dni. Możesz ręcznie odnowić swoje konto po %{manual_renewal_available_at} lub aktywować automatyczne odnawianie teraz.',
      reactivate_heading: 'Zacznijmy od początku.',
      reactivate_content_top_pro:
        'Możesz reaktywować subskrypcję %{planName} tak, jakby nigdy jej nie anulowano. Ewentualnie możesz też przejść na plan WeTransfer Premium:',
      reactivate_content_top_premium:
        'Możesz reaktywować subskrypcję %{planName} tak, jakby nigdy jej nie anulowano.',
      reactivate_content_bottom_pro:
        'Jeśli wybierzesz ulepszenie do wersji Premium, obciążymy Cię opłatą %{upfront_payment} oraz otrzymasz natychmiastowy dostęp do usługi WeTransfer Premium. Twoja nowa subskrypcja %{recurring_payment}/%{interval} zostanie odnowiona %{recurring_date}.',
      reactivate_pro: 'Reaktywuj konto Pro',
      reactivate_premium: 'Reaktywuj konto Premium',
      reactivate_upgrade_to_premium: 'Ulepsz do wersji Premium',
      reactivating: 'Reaktywowanie...',
      subscription_cancelled:
        'Twoja subskrypcja została anulowana i automatycznie wygaśnie za %{daysBetween} dni.',
      subscription_reactivate_expired_notice:
        'Twoje konto Pro zostało anulowane.',
      subscription_reactivate_notice_pro:
        'Twoja subskrypcja %{planName} została anulowana i automatycznie wygaśnie za %{daysBetween} dni.',
      subscription_reactivate_notice_premium:
        'Twoja subskrypcja %{planName} została anulowana i automatycznie wygaśnie za %{daysBetween} dni.Chcesz zmienić zdanie? Bez obaw, możesz z łatwością przywrócić swoje konto.',
      subscription_reactivate_notice_trial_before:
        'Twoja subskrypcja %{planName} została anulowana i automatycznie wygaśnie za %{daysBetween} dni.Możesz nadal korzystać z wersji próbnej WeTransfer Premium do momentu zakończenia subskrypcji.',
      subscription_reactivate_notice_trial_after:
        'Twoja subskrypcja %{planName} została anulowana i automatycznie wygaśnie za %{daysBetween} dni.Możesz nadal korzystać z wersji próbnej WeTransfer Premium do %{trialExpiryDate}.',
      update_method_link: 'Aktualizuj dane dotyczące płatności',
      autorenew_notice_teams:
        'Twoja subskrypcja %{planName} o wartości %{deal} zostanie automatycznie odnowiona dla Twojego zespołu składającego się z %{number_of_members} członków w dniu %{autorenewal_attempt}.',
      cancellation_cta: 'Anuluj subskrypcję',
      cancellation_heading: 'Nie potrzebujesz już korzyści konta %{planName}?',
      cancellation_heading_trial: 'Anuluj subskrypcję',
      cancellation_text:
        'W przypadku anulowania subskrypcji możesz nadal korzystać z funkcji Pro do %{subscriptionExpiryDate}. Po tym czasie Twoje konto WeTransfer Pro zostanie przekształcone w konto bezpłatne, a dotychczasowe transfery wygasną 28 dni później.',
      cancellation_text_item_1: 'Wysyłaj do %{transfer_limit}',
      cancellation_text_item_2: 'Zabezpieczaj transfery hasłem',
      cancellation_text_item_3:
        'Przechowuj %{storage_limit} transferów i zarządzaj nimi',
      cancellation_text_item_4:
        'Uzyskaj własny adres URL i niestandardową stronę Pro',
      cancellation_text_item_heading:
        'Bezpłatne konto umożliwia wysyłanie maksymalnie %{free_size_limit} na transfer. Nie będziesz już mieć możliwości:',
      cancellation_text_new:
        'Jeśli anulujesz subskrypcję teraz, będziesz mieć możliwość dalszego korzystania z planu %{planName} do %{subscriptionExpiryDate}.<br /><br /> Po tym czasie plan zostanie zmieniony na bezpłatny.<br /><br />Uwaga: wszystkie obecne transfery wygasną maksymalnie 28 dni po zakończeniu subskrypcji.',
      cancellation_text_teams:
        'Jeśli zrezygnujesz z subskrypcji teraz, Ty i Twój zespół będziecie mogli korzystać z planu %{planName} do dnia %{subscriptionExpiryDate}.<br /><br />Po tym terminie Ty i członkowie Twojego zespołu nie będziecie mieli możliwości przesyłania plików, tworzenia slajdów prezentacji i wspólnego tworzenia tablic. Plan zostanie zmieniony na bezpłatny oraz będziesz mieć możliwość zalogowania się wyłącznie na własne konto WeTransfer.<br /><br />Uwaga: wszystkie obecne transfery wygasną maksymalnie 28 dni po zakończeniu subskrypcji.',
      premium_trial: {
        feature_list_item_1: 'Brak limitów wielkości transferów',
      },
      premium_upgrade: {
        cta: 'Przejdź na Premium',
        description:
          'Obciążymy Cię opłatą %{upfront_payment} oraz otrzymasz natychmiastowy dostęp do usługi WeTransfer Premium. Twoja nowa subskrypcja %{recurring_payment}/%{interval} zostanie odnowiona %{recurring_date}.',
        feature_list_item_1:
          'Wysyłaj transfery bez ograniczeń wielkości plików',
        feature_list_item_2: 'Nieograniczone przechowywanie plików',
        feature_list_item_3: 'Portale i przegląd bez ograniczeń',
        feature_list_item_4: '%{storageLimit} miejsca',
        heading: 'Chcesz ulepszyć swój plan?',
      },
      unpaid_invoices: {
        heading: 'Masz niezapłacone faktury',
        item: {
          issued_on: 'Data wystawienia',
          pay_invoice: 'Zapłać fakturę',
          pending_invoice: 'W toku...',
        },
        subheading:
          'Wygląda na to, że wystąpił problem z wcześniejszymi płatnościami. Ureguluj wszystkie zaległe faktury, aby uniknąć anulowania subskrypcji Pro.',
        subheading_2:
          'Jeśli masz faktury oczekujące na rozliczenie, spróbujemy ponownie za kilka dni. Po pomyślnym dokonaniu płatności wszystko będzie gotowe.',
      },
      upgrade_cta: 'Ulepsz',
      app_subscription_banner: {
        title: 'Masz subskrypcję w usłudze %{app_name}',
        content:
          'Aby wyświetlić swoją subskrypcję lub zarządzać nią, zaloguj się na swoje konto %{app_name} na telefonie lub komputerze.',
        go_to: 'Przejdź do usługi',
        learn_more: 'Dowiedz się więcej',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Anuluj subskrypcję',
      cancellation_disclaimer:
        '* Twoje obecne transfery wygasną maksymalnie 28 dni po zmianie konta na niższą wersję.',
      'current-plan': 'Aktualny plan',
      'free-forever': 'Zawsze bezpłatnie',
      'free-usp-1': 'Wysyłanie do 2 GB',
      'free-usp-2': 'Brak miejsca',
      'free-usp-3': 'Transfery wygasają po 7 dniach*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Jeśli anulujesz subskrypcję teraz, będziesz mieć możliwość dalszego korzystania z WeTransfer Pro do <b>%{expiration_date}</b>. Następnie poziom Twojego konta zostanie zmieniony na bezpłatne konto WeTransfer – które nadal jest całkiem niezłe.',
      pagename: 'Nie potrzebujesz już korzyści konta Pro?',
      'pro-usp-1': 'Wysyłanie i odbieranie plików do %{transfer_limit}',
      'pro-usp-2': '1 TB miejsca',
      'pro-usp-3': 'Decydujesz, kiedy transfery wygasają',
      'pro-usp-4':
        '<p>Twoja własna strona <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Dostęp do usług Paste® Pro i Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Anulowano subskrypcję – Twoje konto zostanie zmienione na bezpłatne po <b>%{ends_at}.</b></p>\n<p>Powiedz nam, dlaczego odchodzisz, abyśmy mogli ulepszyć usługę WeTransfer z myślą o Tobie.</p>',
      reason_header: 'Przykro nam, że odchodzisz',
      cancel: 'Wróć',
      info: 'Powiedz nam, dlaczego odchodzisz, abyśmy mogli wprowadzać dalsze ulepszenia w usłudze WeTransfer Pro z myślą o Twoich potrzebach.',
      pagename: 'Zanim odejdziesz',
      yes_disable: 'Tak, proszę',
    },
    payment_failed: {
      selected_product: 'Jeden %{duration} z %{planTier}',
      change: 'Aktualizuj',
      complete_order: 'Sfinalizuj zamówienie',
      description: 'Sprawdź swoje dane i sfinalizuj zamówienie',
      description_error: 'Wystąpił błąd – sprawdź swoje dane i przejdź do kasy',
      description_refused:
        'Nie można przetworzyć Twojej płatności – sprawdź dane dotyczące płatności i spróbuj ponownie',
      discount: 'Zniżka',
      product_description: 'Jeden %{duration} korzystania z WeTransfer Pro',
      title: 'Już prawie gotowe!',
      total: 'Razem',
      vat: 'Podatek VAT',
      your_details: 'Twoje dane',
      your_order: 'Twoje zamówienie',
      title_error: 'Wygląda na to, że wystąpił problem',
      title_refused: 'Wygląda na to, że wystąpił problem',
      payment_status_message:
        'Twoja płatność została zrealizowana, ale wystąpił błąd i automatyczna aktualizacja planu nie powiodła się. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Skontaktuj się z zespołem wsparcia</a>',
    },
    payment_methods: {
      billed_now: 'Rozliczane teraz',
      info_content: {
        cancel_bullet:
          'Bez obaw – opcję anulowania możesz znaleźć w menu Ustawienia konta > Płatność.',
        initial_payment_bullet:
          'Po wniesieniu początkowej płatności będziemy naliczać opłaty w wysokości %{price}/%{interval} (chyba że anulujesz subskrypcję – ale mamy nadzieję, że tego nie zrobisz... Prawda?)',
        update_payment_bullet:
          'Zawsze możesz zaktualizować swoje dane dotyczące płatności i/lub informacje rozliczeniowe przed terminem kolejnej płatności.',
        month:
          'Po wniesieniu początkowej płatności będziemy naliczać opłaty w wysokości %{price} każdego miesiąca (chyba że anulujesz subskrypcję – ale mamy nadzieję, że tego nie zrobisz... Prawda?)\n- Opcję anulowania możesz znaleźć w menu Ustawienia konta > Płatność.\n- Zawsze możesz zaktualizować metodę płatności i/lub dane biznesowe przed terminem kolejnej płatności.',
        year: 'Po wniesieniu początkowej płatności będziemy naliczać opłaty w wysokości %{price} raz w roku (chyba że anulujesz subskrypcję – ale mamy nadzieję, że tego nie zrobisz... Prawda?)\n- Opcję anulowania możesz znaleźć w menu Ustawienia konta > Płatność.\n- Zawsze możesz zaktualizować metodę płatności i/lub dane biznesowe przed terminem kolejnej płatności.',
      },
      payment_cta: 'Dokończ płatność',
      payment_term: {
        monthly: 'raz w miesiącu',
        yearly: 'raz w roku',
      },
      payment_title: 'Płatność',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Miesięcznie',
        year: 'Rocznie',
      },
      subtotal: 'Suma częściowa',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Twoja metoda płatności',
      bancontact: 'Bancontact',
      card: 'Karta kredytowa',
      card_cvc: 'Kod CVC',
      card_expiration: 'MM/RR',
      card_name: 'Imię i nazwisko na karcie',
      card_number: 'Numer karty',
      complete_payment: 'Sfinalizuj płatność',
      creditcard: 'Karta kredytowa',
      discount: 'Zniżka',
      do_not_refresh: 'Nie odświeżaj ani nie zamykaj tej strony',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL to metoda płatności online stosowana w Holandii, która umożliwia użytkownikom dokonywanie płatności bezpośrednio ze swojego konta bankowego',
      info: 'Zaktualizuj metodę płatności',
      payment_in_progress: 'Przetwarzanie płatności...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/miesiąc',
        year: '/rok',
      },
      select_bank: 'Wybierz swój bank',
      select_country: 'Wybierz kraj',
      sofort: 'SOFORT',
      tax: 'Podatek VAT',
      title: 'Wybierz metodę płatności',
      total: 'Razem',
    },
    projects: {
      actions: {
        go_back: 'Wszystkie projekty',
        discard: 'Odrzuć zmiany',
        edit: 'Edytuj',
        remove_transfer:
          'Skasować ten transfer? Pliki zostaną usunięte z tego projektu i wysłanych transferów.',
        save: 'Zapisz',
        share: 'Udostępnij',
      },
      transfer_actions: {
        download: 'Pobierz',
      },
      added_at: 'o %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Kopiuj link',
        link_copied: 'Link skopiowany do schowka',
        content_label: 'Skopiuj link do tego projektu',
        list_item_1: 'Dostęp tylko do pobierania i wyświetlania',
        list_item_2: 'Link przez cały czas pozostaje niezmienny',
        title: 'Udostępnij projekt',
      },
      content: {
        empty_state:
          'Twój projekt jest obecnie pusty. Zacznij od dodania kilku plików, aby zapoczątkować oś czasu projektu.',
      },
      logo_title: 'Wróć do wetransfer.com',
      logo_tooltip_caption: 'Wróć do WeTransfer',
      timestamp: '%{timeAgo} temu',
      chat: {
        owner_button_label: 'Opowiedz nam, w czym rzecz',
        owner_offline_greeting:
          'Obecnie jesteśmy w trybie offline – daj nam znać, na czym polega problem, a skontaktujemy się z Tobą w ciągu jednego dnia roboczego.',
        owner_online_greeting:
          'Daj nam znać, na czym polega problem, a skontaktujemy się z Tobą tak szybko, jak to tylko możliwe',
        receiver_button_label: 'Masz pytania? Z chęcią pomożemy',
        receiver_offline_greeting:
          'Daj nam znać, na czym polega problem, a skontaktujemy się z Tobą tak szybko, jak to tylko możliwe.',
        receiver_online_greeting:
          'Daj nam znać, na czym polega problem, a skontaktujemy się z Tobą tak szybko, jak to tylko możliwe.',
      },
      created_by: 'Twórca: %{user}',
      created_by_fallback: 'Utworzono',
      deliverable_clipboard_modal: {
        content_label: 'Skopiuj link do tego elementu dostarczanego',
        info: 'Użytkownicy będą mogli również zobaczyć Twój projekt',
        title: 'Udostępnij element dostarczany',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'To nie jest projekt, którego szukasz…',
        limit:
          'Twój potencjał nie zna granic, lecz limit znaków został przekroczony',
        required: 'Znasz zasady. Nie możesz pominąć wypełnienia tego pola',
      },
      event: {
        project_created_byline:
          'Dodaj kilka plików, aby pokazać, nad czym pracujesz.',
        project_created_title: 'Rozpoczęcie projektu',
      },
      file_count: {
        one: '%{count} plik',
        other: 'Pliki: %{count}',
      },
      just_now: 'przed chwilą',
      labels: {
        description: 'Opis',
        name: 'Nazwa',
        new_name: 'Nazwij swój projekt',
      },
      logo: {
        cta: 'Dodaj logo',
        errors: {
          dimensions:
            'Twoje logo jest mniejsze niż 220 x 220 pikseli. Spróbuj użyć większego obrazu',
          general: 'Wystąpił błąd. Spróbuj ponownie',
          size: 'Twoje logo jest większe niż 5 MB. Spróbuj użyć mniejszego pliku',
          type: 'Twoje logo nie jest plikiem w formacie JPEG, GIF ani PNG. Spróbuj użyć innego obrazu',
        },
        instructions:
          'Twoje logo może mieć maksymalnie 5 MB. Akceptowalne są pliki w formacie JPEG i GIF, lecz najlepiej sprawdzają się pliki PNG z przezroczystym tłem',
        'instructions-title': 'Prezentacja swojej marki',
      },
      name_modal: {
        content_label: 'Nazwij swój projekt lub zmień jego nazwę',
        input_placeholder_0: 'Zdecydowanie Lwy z Cannes',
        input_placeholder_1: 'Lekarstwo na przeziębienie',
        input_placeholder_2: 'Zbrodnia doskonała',
        input_placeholder_3: 'Piszę piosenki, nie tytuły',
        input_placeholder_4: 'Obsypany nagrodami pomysł',
        input_placeholder_5: 'Nowa kampania marki',
        input_placeholder_6: 'Przejęcie władzy nad światem',
        save: 'Zapisz',
        text: 'Opisz projekt, nad którym pracujesz.',
        title: 'Nazwij swój projekt',
      },
      new_project_label: 'Rozpocznij nowy projekt',
      noticebar: {
        'button-cancel': 'Anuluj',
        'button-clear-all-files': 'Wyczyść wszystko',
        'button-close': 'Zamknij',
        'button-delete': 'Usuń',
        'button-no': 'Nie',
        'button-share': 'Udostępnij',
        'button-yes': 'Tak',
        'confirm-cancel': 'Anulować ten transfer?',
        'confirm-clear-files-deliverable':
          'Wyczyścić wszystkie pliki z <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Przesyłanie ukończone! Daj znać wszystkim, że dodano więcej plików.',
        'confirm-delete-deliverable':
          'Usunąć element <strong><u>%{deliverableName}</u></strong> oraz wszystkie przesłane do niego pliki?',
        'confirm-first-complete':
          'Przesyłanie ukończone! Udostępnij ten projekt, aby umożliwić pobranie plików.',
        deliverable_not_found_error:
          'Wygląda na to, że element dostarczany został usunięty',
        general_error: 'Wystąpił błąd. Spróbuj ponownie.',
      },
      'onboarding-promise': {
        description:
          'Przedstaw w zarysie wszystkie prace, które wykonasz w ramach projektu, i usprawnij sposób udostępniania ich. Utwórz listę elementów dostarczanych, a następnie dodawaj pliki w miarę postępu prac – nie musisz już używać wielu różnych linków do pobrania.',
        title: 'Obierz dobry kurs na samym początku i pozostań na nim',
      },
      onboarding: {
        banner:
          'Wybrano Cię jako jedną z nielicznych osób, które otrzymają dostęp do usługi Projects w trakcie jej tworzenia (i ulepszania). Możemy skontaktować się z Tobą w celu uzyskania informacji zwrotnej.',
      },
      pagename: 'Projekty',
      placeholders: {
        description: 'Podaj krótki opis swojego projektu',
        loading: 'Ładowanie...',
      },
      project: {
        notification: {
          name_saved: 'Nazwa zapisana! Twój projekt wygląda zachęcająco.',
        },
      },
      share_button_label: 'Udostępnij',
      unnamed_project_title: 'Projekt bez nazwy',
      watch_video: 'Obejrzyj film',
    },
    transfer: {
      display_name_fallback: 'Transfer bez tytułu',
      does_not_expire: 'brak <u>daty wygaśnięcia</u>',
      expires_in: 'Wygasa za: <span>%{time}</span>',
      downloaded_at: 'Pobrano %{date} o godzinie %{time}',
      not_downloaded: 'Jeszcze nie pobrano',
      email_bounced: 'Adres, na który to wysłano, nie działa',
      count_files: {
        one: '%{count} plik',
        other: 'Pliki: %{count}',
      },
      sent_datetime: 'Wysłano %{date} o godzinie %{time}',
      never_expires: 'Brak daty wygaśnięcia',
      and_more: 'I %{count} więcej',
      read_more: 'więcej',
      copy_link: 'skopiuj link',
      message: 'Wiadomość',
      total_downloads: 'Łączna liczba pobrań',
      sent_to_recipients: {
        one: 'Wysłano do %{count} osoby',
        other: 'Wysłano do %{count} osób',
      },
      no_transfers:
        'Tutaj pojawią się wszystkie wysłane przez Ciebie transfery',
      add_first_description:
        'Sprawdź stan pobierania lub edytuj, prześlij dalej bądź usuń je',
      mobile: {
        download: 'Pobierz wszystkie pliki',
        remove: 'Usuń transfer',
      },
      delete_datetime: 'Usunięto pliki %{date} o godzinie %{time}',
      detail: {
        plus_download_stats:
          'Wybierz plan Pro, aby śledzić, ile razy Twoje transfery są pobierane.',
        plus_password_expiration:
          'Wybierz plan Pro, aby ustawiać hasła oraz daty wygaśnięcia swoich transferów.',
        plus_transfer_actions:
          'Wybierz plan Pro, aby zarządzać swoimi transferami i usuwać je w dowolnym momencie.',
        title: 'Dane Twojego transferu',
      },
      download_status_email: '%{count}/%{total} osób',
      download_status_email_text: {
        zero: 'Jeszcze nie pobrano',
        one: '%{count}/%{total} osób',
        other: '%{count}/%{total} osób',
      },
      download_status_link: {
        one: 'jeden raz',
        other: '%{count} razy',
      },
      download_status_link_text: {
        zero: 'Jeszcze nie pobrano',
        one: '1 raz',
        other: '%{count} razy',
      },
      sent_moment: 'Wysłano %{moment}',
      total_downloads_tooltip:
        'Coś wygląda inaczej? Niedawno wprowadziliśmy małą zmianę. Ta liczba wskazuje tylko ukończone pobrania.',
      display_name: {
        label: 'Tytuł',
        label_mobile:
          'Dodaj tytuł, aby wszyscy wiedzieli, co zawiera Twój transfer',
      },
      download_status_received_text: {
        zero: 'Jeszcze nie pobrano',
        one: 'Pobrano',
        other: 'Pobrano',
      },
      edit_display_name: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        title: 'Tytuł',
      },
      received_datetime: 'Otrzymano %{date} o godzinie %{time}',
      received_from: 'Otrzymano od',
      received_moment: 'Otrzymano %{moment}',
      teams: {
        received_by: 'Otrzymane przez',
        self: 'ja',
        sent_by: 'Wysłane przez',
      },
      title: 'Tytuł',
      set_password: {
        added: 'Dodano',
        change: 'Zmień',
        remove: 'Usuń',
        description:
          'Ustaw hasło, aby kontrolować, kto ma dostęp do tego transferu.',
        remove_warning: 'Usunąć ochronę hasłem z tego transferu?',
        yes_remove: 'Tak, usuń',
      },
      set_expiration: {
        description:
          'Ustaw datę wygaśnięcia, aby ograniczyć dostęp do tego transferu.',
        label: 'Wygasa za',
      },
      anon_upsell_no_account:
        'Aby edytować lub śledzić pobrania dla tego transferu przed jego wygaśnięciem, <a href="%{href}">zarejestruj się</a> bezpłatnie.',
      anon_upsell_found_account:
        'Aby edytować lub śledzić pobrania dla tego transferu przed jego wygaśnięciem, <a href="%{href}">zaloguj się</a>.',
      anon_upsell_no_account_with_button:
        'Możesz edytować ten transfer przed jego wygaśnięciem, tworząc konto.',
      create_free_account: 'Utwórz bezpłatne konto',
    },
    transfers: {
      space_used_unlimited: ' Wykorzystano %{space} miejsca',
      pagename: 'Transfery',
      search: 'wyszukaj nazwę pliku',
      search_results: {
        one: '%{count} wynik wyszukiwania',
        other: 'Wyniki wyszukiwania: %{count}',
        none: 'Brak wyników',
        retry:
          'Wygląda na to, że nie znaleziono transferu zgodnego z Twoim wyszukiwaniem – spróbuj ponownie.',
      },
      space_used: 'Użyto: %{space} z %{totalSpace}',
      selected_text: {
        one: 'Wybrano %{count} transfer (%{size})',
        other: 'Wybrano transfery: %{count} (%{size})',
      },
      last_7_days: 'Wysłane w ciągu ostatnich 7 dni',
      over_7_days: 'Wysłane więcej niż 7 dni temu',
      sort_on: 'Sortuj według:',
      size: 'Wielkość',
      name: 'Nazwa',
      date: 'Data',
      delete: 'Usuń',
      download: 'Pobierz',
      forward: 'Prześlij dalej',
      remove: 'Usuń',
      select: 'Wybierz',
      copy_link: 'Kopiuj link',
      sent_time_ago: 'Wysłano %{timeAgo} temu',
      files: {
        one: '%{count} plik',
        other: 'Pliki: %{count}',
      },
      confirm_transfer_delete:
        'Moment – czy na pewno chcesz usunąć ten transfer?',
      confirm_forward:
        'Przekazanie tego dalej spowoduje zastąpienie transferu w toku. Kontynuować?',
      confirm_expired_transfer_delete:
        'Spowoduje to trwałe usunięcie plików i informacji o transferze. Kontynuować?',
      deleting_now: 'Usuwanie jest teraz w toku',
      deselect_all_transfers: {
        one: 'Odznacz wszystkie transfery',
        other: 'Odznacz wszystkie transfery (%{count})',
      },
      downloads: 'Pobrania',
      expiration: 'Daty wygaśnięcia',
      expiration_next: 'Wygasa w ciągu %{days}',
      expiration_no_date: 'Brak daty wygaśnięcia',
      expiration_not_soon: 'Nie wygasa w najbliższym czasie',
      include_archived_switch_label:
        'Uwzględnij informacje o usuniętych transferach',
      include_archived_switch_tooltip:
        'Nie wliczają się one do limitu miejsca przechowywania',
      notify_completed:
        'Transfer ukończony. Możesz zamknąć ten panel. Albo popatrz jeszcze chwilę.',
      preview: 'Podgląd',
      remove_permanently: 'Usuń informacje na zawsze',
      search_placeholder: 'Wyszukaj według nazwy pliku lub adresu e-mail',
      select_all_transfers: {
        one: 'Wybierz wszystkie transfery',
        other: 'Wybierz wszystkie transfery: %{count}',
      },
      space_left: 'Pozostało %{space} z %{totalSpace}',
      teams_tip: {
        subtitle:
          'Na tej stronie pokazana jest Twoja aktywność dotycząca transferów. Żeby nie było wątpliwości, członkowie Twojego zespołu również widzą tylko swoje transfery.',
        title: 'Twój zespół Pro się powiększa...',
      },
      title: 'Wysłane transfery',
      view_details: 'Zobacz szczegóły',
      edit_display_name: 'Edytuj tytuł',
      received_time_ago: 'Otrzymano %{timeAgo} temu',
      search_title_placeholder:
        'Szukaj według tytułu, nazwy pliku lub adresu e-mail',
      see_all: 'Zobacz wszystkie (%{count})',
      sender: 'Nadawca',
      sort_by_title: 'Tytuł',
    },
    accountinfo: {
      pagename: 'Informacje o koncie',
      signed_in_as: 'Zalogowano jako %{name}',
      sign_out: 'Wyloguj się',
      paid_on: 'Zapłacono w dniu',
      no_invoices:
        'Twoje rachunki pojawią się tutaj, ale wygląda na to, że jeszcze żadnych nie posiadasz. Masz szczęście!',
      subscription_info:
        'Twoja subskrypcja Pro %{deal} zostanie odnowiona automatycznie %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          'Doskonale – przed Tobą cały miesiąc korzystania z WeTransfer Pro',
        monthly_renewal:
          'Doskonale – przed Tobą kolejny miesiąc korzystania z wersji Pro',
        yearly: 'Doskonale – przed Tobą cały rok korzystania z WeTransfer Pro',
        yearly_renewal:
          'Doskonale – przed Tobą kolejny rok korzystania z wersji Pro',
      },
    },
    changepassword: {
      pagename: 'Zmień hasło',
    },
    invoices: {
      pagename: 'Pokwitowania wpłat',
    },
    reviewbilling: {
      pagename: 'Potwierdź swoje dane dotyczące płatności',
      information:
        'Aby zmienić metodę płatności, musimy jednocześnie odnowić subskrypcję',
      information_payment:
        'Obciążymy Cię kwotą %{deal} za następny %{period} planu Pro – Twoja subskrypcja będzie ważna do %{expiry}',
    },
    renewbilling: {
      pagename: 'Sprawdź swoje dane i odnów',
    },
    link_downloads_unsubscribe: {
      body: 'Możesz anulować subskrypcję powiadomień o pobraniu transferu wysłanego za pomocą linku – nadal będziesz mieć możliwość śledzenia pobrań w panelu Wysłane.',
      cta: 'Przejdź do moich wysłanych transferów',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Wybierz z galerii',
        },
        next_button: 'Wszystko gotowe',
        description:
          'Wybierz własne tapety na swoją nową, efektowną stronę WeTransfer. Możesz dodać maksymalnie pięć filmów lub obrazów wyświetlanych rotacyjnie, aby wyeksponować swoją firmę lub markę.',
      },
      upload_wallpaper: {
        add_text: 'Prześlij obraz',
        add_description:
          'Aby uzyskać najlepsze rezultaty, sugerujemy przesłanie obrazu w rozdzielczości 2560 x 1600 pikseli. Maksymalna wielkość pliku wynosi 3 MB.',
        upload_text: 'Prześlij obraz lub film',
      },
      preview: {
        wallpaper_credits_prefix: 'Autor tapety',
      },
      1: {
        description:
          'Określ, co użytkownicy zobaczą za każdym razem, gdy wyślesz im pliki. Ponadto dzięki własnej stronie WeTransfer każdy może wysłać Ci transfery do %{transfer_limit} – wystarczy podać swój adres URL. Twój adres e-mail będzie wyświetlany na stronie, aby wszyscy mieli pewność, że ich pliki zostaną wysłane właśnie do Ciebie.<br /><br />\nNajpierw wybierz swój adres URL.',
        next: 'Dalej',
        skip: 'Pomiń',
        warning:
          '<strong>Uwaga:</strong> możesz to ustawić tylko raz (zero presji!)',
        'blurb-1':
          'Stwórz własną stronę WeTransfer, która będzie wyglądała profesjonalnie za każdym razem, gdy ktoś pobiera Twoje pliki – oraz sprawi, że wysyłanie transferów do Ciebie stanie się (jeszcze) łatwiejsze.',
        'blurb-2': 'Najpierw wybierz swój adres URL.',
        welcome: 'Stwórz własną przestrzeń, konfigurując stronę WeTransfer',
        information:
          'Bez obaw – zawsze możesz to zmienić później w sekcji <strong>Branding</strong>.',
        description_unlimited:
          'Określ, co użytkownicy zobaczą za każdym razem, gdy wyślesz im pliki. Ponadto dzięki własnej stronie WeTransfer każdy może wysłać Ci transfery dowolnej wielkości – wystarczy podać swój adres URL. Twój adres e-mail będzie wyświetlany na stronie, aby wszyscy mieli pewność, że ich pliki zostaną wysłane właśnie do Ciebie.<br /><br />\nNajpierw wybierz swój adres URL.',
      },
      2: {
        description:
          'Możesz wybrać do pięciu różnych teł (nazywanych przez nas tapetami) dla swojej strony WeTransfer.\n\nPostaw siebie lub swoją markę w centrum uwagi i dostarczaj pliki we własnym stylu',
        pick: 'Wybierz z naszej galerii',
        title: 'Niech każdy transfer robi wspaniałe wrażenie',
        upload: 'Prześlij własne pliki',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> jest skonfigurowany. Teraz możesz dodać ten link do swojej strony internetowej, aby umożliwić innym osobom wysłanie do Ciebie transferów do %{transfer_limit} – lub po prostu samemu coś wysłać.',
        done: 'Gotowe',
        title: 'Wygląda wspaniale!',
        description_unlimited:
          '<strong>%{customLink}</strong> jest skonfigurowany. Teraz możesz dodać ten link do swojej strony internetowej, aby umożliwić innym osobom wysłanie do Ciebie transferów dowolnej wielkości – lub po prostu samemu coś wysłać.',
      },
    },
    contact: {
      add_contact: 'Dodaj kontakt',
      add_first_description:
        'Zapiszemy tu również adresy e-mail, na które wysyłasz pliki',
      add_to_transfer: 'Dodaj do transferu',
      remove_from_transfer: 'Usuń z transferu',
      confirm_delete: {
        one: 'Czy na pewno chcesz usunąć ten kontakt?',
        other: 'Czy na pewno chcesz usunąć kontakty (%{count})?',
      },
      contact_count: {
        one: '%{count} kontakt',
        other: 'Kontakty: %{count}',
      },
      edit: 'Edytuj',
      mobile: {
        add: 'Dodaj kontakt',
      },
      no_contacts: 'Dodaj swój pierwszy kontakt!',
      pagename: 'Kontakty',
      remove: 'Usuń',
      search_count: {
        one: '%{count} wynik wyszukiwania',
        other: 'Wyniki wyszukiwania: %{count}',
      },
      search_placeholder: 'wyszukaj adres e-mail, imię i nazwisko lub firmę',
      select: 'Wybierz',
      selected_text: {
        one: 'Wybrano %{count} kontakt',
        other: 'Wybrano kontakty: %{count}',
      },
      teams_tip: {
        subtitle:
          'Gdy wyślesz komuś transfer, odbiorca zostanie dodany do Twojej listy kontaktów. Wszyscy członkowie Twojego zespołu mogą tworzyć własną listę.',
        title: 'Twój zespół Pro się rozszerza...',
      },
    },
    unsubscribeexpiration: {
      button: 'Anuluj subskrypcję',
      button_unsubscribed: 'Wróć do WeTransfer',
      description:
        'Masz dość wiadomości e-mail od nas? Nie ma problemu, możemy przestać przypominać Ci o zbliżającym się terminie wygaśnięcia transferów.',
      description_unsubscribed:
        'Nie będziesz otrzymywać więcej wiadomości e-mail z informacją o wygaśnięciu transferów',
      no_email: 'Ty',
      title: 'Anuluj subskrypcję wiadomości e-mail z przypomnieniem',
      title_unsubscribed: 'Wszystko gotowe!',
      downloaded: {
        body: 'Rozumiemy. Możesz anulować subskrypcję przypomnień o zbliżającym się terminie wygaśnięcia transferu, gdy Twoje pliki zostały już pobrane. Nie będzie to miało wpływu na wiadomości e-mail z przypomnieniem dotyczące plików, które nie zostały jeszcze pobrane.',
        cta: 'Anuluj subskrypcję',
        title:
          '„Moje pliki zostały pobrane, nie potrzebuję wiadomości e-mail o wygasających transferach“',
      },
      not_downloaded: {
        body: 'Nie ma sprawy. Możesz anulować subskrypcję przypomnień o zbliżającym się terminie wygaśnięcia transferu nawet wtedy, gdy Twoje pliki nie zostały jeszcze pobrane.',
        cta: 'Anuluj subskrypcję',
        title:
          'Nie potrzebujesz otrzymywać wiadomości e-mail z informacją o wygaśnięciu transferów?',
      },
      pro: {
        body_1:
          'W porządku, możesz anulować subskrypcję tych przypomnień. W szczegółach transferu możesz nadal śledzić, kiedy transfery wygasają, oraz zmieniać daty wygaśnięcia w dowolnej chwili.',
        body_2:
          'Jeśli zmienisz zdanie lub pojawi się jakikolwiek problem, możesz do nas napisać na adres <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>.',
        cta: 'Anuluj subskrypcję',
        title:
          'Nie potrzebujesz otrzymywać wiadomości e-mail z informacją o wygaśnięciu transferów?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Czy na pewno chcesz wyczyścić pliki cookie?',
        },
      },
    },
    about_plus: {
      checklist: {
        title:
          'Ulepsz do wersji Pro już dziś, płacąc %{price} %{currency} miesięcznie',
      },
    },
    advertise: {
      gallery: {
        preview: 'Podgląd',
      },
      guidelines: {
        advert_static: {
          title: 'Statyczna tapeta',
        },
      },
    },
    billinginfo: {
      pagename: 'Informacje rozliczeniowe',
    },
    help: {
      button_all_answers: 'Więcej odpowiedzi',
      page_title: 'Szybka pomoc',
      read_more: 'Więcej informacji',
      search_button: 'Szukaj',
      search_placeholder: 'W czym możemy Ci pomóc?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Ładowanie...',
    },
    payment_update: {
      bancontact: {
        info: 'Uwaga – Bancontact pobierze jednorazową opłatę w wysokości 0,50 EUR za sprawdzenie poprawności danych',
      },
      confirm_update: 'Potwierdź',
      ideal: {
        info: 'Uwaga – iDEAL pobierze jednorazową opłatę w wysokości 0,01 EUR za sprawdzenie poprawności danych',
      },
      info: 'Uwaga – iDEAL pobierze jednorazową opłatę w wysokości 0,01 EUR za sprawdzenie poprawności danych',
      sofort: {
        info: 'Uwaga – SOFORT pobierze jednorazową opłatę w wysokości 1 EUR za sprawdzenie poprawności danych',
      },
      title: 'Aktualizuj dane dotyczące płatności',
      update_in_progress: 'Aktualizacja danych...',
    },
    sign_in: {
      account: 'Nie masz konta?',
      upgrade: 'Ulepsz do wersji Pro',
    },
    signin: {
      account_cta: 'Utwórz konto',
      account_item_1: 'Wysyłaj do %{size_limit}',
      account_item_2: 'Zarządzaj transferami',
      account_item_3: 'Przechowuj do %{storage_limit}',
      account_subtitle: 'Free',
      plus_cta: 'Wybierz WeTransfer Pro',
      plus_item_1: 'Wysyłaj do %{size_limit}',
      plus_item_2: 'Zarządzaj transferami',
      plus_item_3: 'Przechowuj do %{storage_limit}',
      plus_item_4: 'Twoje własne tła',
      plus_item_5: 'Niestandardowy adres URL',
      plus_item_6: 'Zabezpieczaj transfery hasłem',
      plus_month: '/miesiąc',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Anuluj zaproszenie',
      },
      invitees: {
        title: 'Wysłano zaproszenie – oczekiwanie na odpowiedź',
      },
      member: {
        action_demote: 'Odbierz uprawnienia administratora',
        action_promote: 'Nadaj uprawnienia administratora',
        action_revoke: 'Usuń z zespołu',
      },
      members: {
        title: 'W Twoim zespole',
      },
      no_access: {
        description: 'Damy Ci znać, gdy wszystko będzie gotowe. ',
        title: 'Wygląda na to, że ta funkcja jest nadal ściśle tajna. ',
      },
      subtitle: {
        members: {
          one: '%{count} członek',
          other: 'Członkowie: %{count}',
        },
        pending: 'Liczba zaproszonych: %{pendingCount}',
      },
      tip: {
        button: 'Dowiedz się więcej',
        subtitle:
          'Nowa funkcja Pro dla zespołów sprawia, że nasza najlepsza usługa WeTransfer jest jeszcze lepsza! Dodawaj nowych członków bezpłatnie. Skorzystaj z łatwego formularza poniżej, aby rozruszać swój zespół – można zacząć już po zaakceptowaniu zaproszenia!',
        title: 'W zespole nie ma miejsca na ego.',
      },
      title: 'Zespół',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Wygaśnie za %{expiry}',
      },
      recipients: 'Wysyłanie do',
      upsell: {
        benefit_one: 'Zobacz, kiedy pliki zostały pobrane',
        benefit_three: 'Przeglądaj i wysyłaj ponownie stare transfery',
        benefit_two: 'Zobacz, kto pobrał Twoje pliki',
        button: {
          action: 'Więcej informacji',
          cancel: 'Nie, dziękuję',
        },
        heading: 'Łatwo zarządzaj swoimi transferami z WeTransfer Pro',
        title: 'Dane Twojego transferu',
      },
    },
    transferReceived: {
      'empty-description':
        'Tutaj znajdziesz wszystkie transfery wysłane do Ciebie – bez obaw, nie zajmują Twojego miejsca w pamięci',
      'empty-title': 'Śledzenie transferów',
    },
    unsubscribeonboarding: {
      action: 'Anuluj subskrypcję',
      back: 'Wróć do WeTransfer',
      contact:
        'Jeśli pojawi się jakikolwiek problem, napisz do nas na adres <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>.',
      done: 'Wszystko gotowe!',
      message:
        'Możesz anulować subskrypcję wiadomości e-mail z wprowadzeniem – bez obaw, nadal będziesz otrzymywać to, co ważne.',
      title: 'Skrzynka odbiorcza się zapełnia?',
    },
    userinfo: {
      pagename: 'Dane osobowe',
    },
    free_onboarding: {
      close: 'Zamknij',
      finish_tour: 'Gotowe',
      next: 'Dalej',
      send_files: 'Po prostu przejdź teraz do wysyłania plików',
      start_tour: 'Zobacz, co jeszcze oferujemy',
      step_one: {
        body_1:
          'Po zweryfikowaniu adresu e-mail swojego konta nie ma potrzeby robić tego przy każdym transferze. Nie musisz już wpisywać kodów weryfikacyjnych!',
        body_2:
          'Śledź wszystkie swoje wysłane i odebrane transfery w jednym miejscu. Zobacz, ile razy Twoje pliki zostały pobrane. Wyślij ponownie, przekaż dalej lub usuń swoje transfery jednym kliknięciem.',
        header_1: 'Zweryfikowano raz na zawsze',
        header_2: 'Zarządzaj swoimi transferami',
        subtitle:
          'Koniec z kodami weryfikacyjnymi i zagubionymi linkami do pobierania. Twoje nowe konto zapewnia najprostszy sposób wysyłania dużych plików – bezpłatnie.',
        title_1: 'Wysyłaj pliki <strong>na swoich warunkach</strong>',
        title_2: 'z WeTransfer',
      },
      step_three: {
        body_1:
          'Zapisz wszystkie inspiracje w jedynym miejscu – niezależnie od tego, czy jest to film na Twoim telefonie, czy też link na komputerze. Aby rozpocząć, otwórz usługę Collect za pomocą przycisku uruchamiania (w lewym górnym rogu) lub użyj poniższego linku.',
        cta: 'Przejdź do Collect',
        title_1: '<strong>Zapisuj inspiracje,</strong> gdy jesteś w ruchu',
        title_2: 'z Collect',
      },
      step_two: {
        body_1:
          'Prezentuj pomysły. Pochwal się pracą w toku. Synchronizuj swoje dane. Koniec z formatowaniem slajdów. Aby rozpocząć, otwórz usługę Paste za pomocą przycisku uruchamiania (w lewym górnym rogu) lub użyj poniższego linku.',
        cta: 'Przejdź do Paste',
        title_1: 'Twórz <strong>slajdy w kilka sekund</strong>',
        title_2: 'z Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Wypróbuj portale',
        pill: 'Nowa funkcja',
        text: 'Przedstawiamy <strong>portale</strong> – prostszy sposób na uzyskanie potrzebnej aprobaty. Zaproś klientów i współpracowników do przeglądania plików i wybierania ulubionych – bez konieczności pobierania.',
        title:
          'Udostępnij pracę. Uzyskaj informację zwrotną. Wszystko w jednym miejscu.',
      },
    },
    not_found: {
      body: 'Wróć do <a href="https://wetransfer.com/">wetransfer.com</a> lub daj się rozweselić <a href="https://wepresent.wetransfer.com/">miłym tekstom, które napisaliśmy</a>.',
      image_alt: 'Wystąpił błąd',
      title: 'Nie znaleziono strony.',
    },
    password_and_security: {
      title: 'Hasło i zabezpieczenia',
      'two-factor-authentication': {
        description: {
          enabled: 'Od %{date}',
        },
        disable: 'Wyłącz',
        done: 'Gotowe',
        enable: 'Włącz',
        get_recovery_codes: 'Uzyskaj kody odzyskiwania',
        next_step: 'Dalej',
        recovery_code_action: 'Generuj nowe kody',
        recovery_code_keep_safe:
          'Każdego kodu można użyć tylko raz, ale zawsze możesz uzyskać ich więcej, jeśli potrzebujesz.',
        recovery_code_need_more:
          'Potrzebujesz więcej kodów odzyskiwania? Zawsze możesz wygenerować nowe, jednak należy pamiętać, że spowoduje to unieważnienie wszystkich obecnych kodów.',
        recovery_code_title: 'Twoje kody odzyskiwania',
        require_password_action: 'Wprowadź',
        require_password_text: 'Wprowadź hasło, aby kontynuować',
        step_one_action: {
          app_store: 'Pobierz w App Store',
          google_play: 'Pobierz w Google Play',
        },
        step_one_label: 'Krok 1 (z 3)',
        step_one_text:
          'Będziesz potrzebować aplikacji uwierzytelniającej na telefonie. Jeśli masz już aplikację Google Authenticator (lub inną), kliknij Dalej.',
        step_one_title: 'Pobierz aplikację Google Authenticator',
        step_three_label: 'Krok 3 (wszystko gotowe!)',
        step_three_text:
          'Jeśli musisz się zalogować, a nie masz przy sobie telefonu (zdarza się), możesz użyć jednego z tych kodów odzyskiwania. Nie zapiszemy tych kodów dla Ciebie ani nie wyświetlimy ich ponownie, dlatego należy pobrać je teraz i przechowywać z taką samą ostrożnością jak hasło do konta bankowego.',
        step_three_text_2:
          'Przechowuj te kody z taką samą ostrożnością jak hasło do konta bankowego! Każdego kodu można użyć tylko raz.',
        step_three_title: 'Zapisz kody odzyskiwania',
        step_two_form: {
          error: 'Ten kod jest nieprawidłowy lub wygasł',
          label: 'Kod weryfikacyjny',
        },
        step_two_label: 'Krok 2 (połowa gotowa)',
        step_two_text:
          'Użyj aplikacji uwierzytelniającej, aby zeskanować ten kod kreskowy. Aplikacja wygeneruje sześciocyfrowy kod weryfikacyjny, który należy wprowadzić poniżej.',
        step_two_text_mobile:
          'Wprowadź ten klucz w aplikacji uwierzytelniającej. Aplikacja wygeneruje sześciocyfrowy kod weryfikacyjny, który należy wprowadzić poniżej.',
        step_two_title: 'Skanuj kod kreskowy',
        step_two_title_mobile: 'Wprowadź klucz',
        text: {
          protect_account:
            'Zyskaj dodatkową warstwę zabezpieczeń konta przy użyciu telefonu.',
        },
        title: 'Uwierzytelnianie dwuskładnikowe',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Wykorzystanie pełnych możliwości usług Paste® i Collect',
      },
      cta: 'Nie, chcę zachować konto Pro',
      'cta-2': 'Anuluj subskrypcję',
      disclaimer: {
        collect:
          'Ilość miejsca w usłudze Collect zmniejszy się z 200 GB do 5 GB',
        paste: 'Zostanie wprowadzony limit 3 zbiorów w usłudze Paste®',
        'team-member':
          'Usuniemy Cię z zespołu %{currentTeam} w WeTransfer Pro.',
        teams:
          'Twój zespół składający się z %{amountOfMembers} członków zostanie usunięty z: %{currentTeam}',
        title:
          'Kiedy Twoja bieżąca subskrypcja zakończy się <strong>%{date}</strong>:',
        'transfer-expiry':
          'Twoje obecne transfery zostaną usunięte po 28 dniach',
        'transfer-team-member':
          'Utracisz możliwość wysyłania i odbierania transferów jako członek zespołu oraz nie będziesz mieć możliwości zarządzania obecnymi transferami zespołu.',
      },
      'password-expiry': {
        title:
          'Zabezpieczanie transferów hasłem i określanie terminu ich wygaśnięcia',
      },
      personalization: {
        title: 'Spersonalizuj swoją stronę WeTransfer',
      },
      portals: {
        text: 'Plan %{planName} pozwala udostępniać klientom projekty do wglądu bez konieczności pobierania za pomocą <a href="%{href}" target="_blank">portali</a>.',
        title:
          'Udostępnianie prac i otrzymywanie informacji zwrotnych w jednym miejscu',
      },
      'stay-pro': 'Zachowaj subskrypcję',
      'storage-limit': {
        title: 'Zachowaj %{storage_limit_pro} na transfery',
      },
      subtitle:
        'Jeśli zrezygnujesz teraz, %{date} utracisz dostęp do poniższych możliwości:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Zaproś członków zespołu</a> do wspólnego wysyłania i odbierania transferów oraz zarządzania nimi – lub pracuj samodzielnie bez opłat.',
        'team-member-text':
          'Usuniemy Cię z Twojego zespołu oraz utracisz możliwość wspólnego wysyłania i odbierania transferów oraz zarządzania nimi.',
        'team-owner-text':
          'Masz obecnie <a href="%{href}" target="_blank">%{amountOfMembers} członków zespołu</a>, którzy utracą możliwość wspólnego wysyłania i otrzymywania transferów oraz zarządzania nimi.',
        title: 'Rozwijaj ważne pomysły wraz z zespołem',
      },
      title: 'Czy naprawdę chcesz zrezygnować z planu %{planName}?',
      'transfer-limit': {
        text: 'Obecnie możesz wysyłać i odbierać większe transfery – o wiele większe niż dostępne bezpłatnie %{transfer_limit_free}.',
        title: 'Udostępnianie ogromnych plików ze swoimi projektami',
      },
      'transfer-unlimited': {
        text: 'Możesz wysyłać (i odbierać) transfery bez ograniczeń wielkości pliku – to nieskończenie więcej niż %{transfer_limit_free} dostępne bezpłatnie.',
        title: 'Wysyłaj transfery dowolnej wielkości',
      },
    },
    pricing: {
      pro: {
        per_person: 'za osobę',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Utwórz konto',
        current_plan: 'Aktualny plan',
        sign_up: 'Zarejestruj się',
        switch_premium: 'Przejdź na Premium',
        switch_pro: 'Przejdź na Pro',
        upgrade: 'Ulepsz',
      },
      faq: {
        answers: {
          answer_1:
            'Można rozpocząć pracę z WeTransfer Pro lub WeTransfer Premium zaraz po sfinalizowaniu płatności. Wyślemy do Ciebie również wiadomość e-mail z potwierdzeniem i załączoną opłaconą fakturą. <br /><br />\n\nGdy wszystko będzie gotowe, natychmiast uzyskasz możliwość wysyłania większych transferów, korzystania z portali oraz utworzenia własnej strony WeTransfer. Jeśli masz jakieś wcześniejsze transfery wysłane podczas korzystania z bezpłatnego planu, możesz również dowolnie zmienić ich daty wygaśnięcia.',
          answer_2:
            'Gdy korzystasz z WeTransfer, wszyscy mogą pobierać Twoje pliki – bez logowania i rejestrowania się. Pobierający muszą zaakceptować nasze Warunki korzystania z usługi oraz mogą zostać poproszeni o zaakceptowanie plików cookie, ale nie muszą robić nic więcej! <br /><br />\n\nJeśli chcesz udostępniać swoją pracę lub współpracować na portalach (które są najnowszą funkcją WeTransfer), Twoi klienci i współpracownicy nie muszą się rejestrować, aby móc przeglądać i wybierać pliki, dodawać komentarze lub zatwierdzać i pobierać pliki. Dodanie członków zespołu do planu Pro lub Premium jest konieczne tylko wtedy, gdy chcesz, aby użytkownicy mogli dodawać przeglądy i współtworzyć portale wraz z Tobą.',
          answer_3:
            'Dzięki planowi Pro lub Premium możesz stworzyć własną stronę WeTransfer, na której każdy może wysyłać Ci pliki w ramach limitu transferu Twojego planu. Oznacza to, że możesz otrzymywać duże pliki od klientów i współpracowników, którzy nie muszą mieć konta – wystarczy adres URL Twojej strony. (Niemniej możemy poprosić ich o zweryfikowanie swoich adresów e-mail, aby chronić Cię przed „zagranicznymi książętami”, którzy „chcą wysłać Ci pieniądze“).',
          answer_4:
            'Musisz najpierw utworzyć konto WeTransfer Pro lub WeTransfer Premium – nie możesz dodawać członków zespołu, korzystając z planu bezpłatnego. Niezależnie od tego, który plan wybierzesz, członkowie Twojego zespołu będą mogli korzystać z tych samych funkcji (nie można na przykład wybrać planu Premium dla siebie oraz planu Pro dla kilku członków zespołu). Członkowie zespołu będą mogli wysyłać i odbierać większe transfery z Twojej strony WeTransfer, a także zarządzać transferami w ramach jednego, wspólnego przeglądu. <br /><br />\n\nPo wybraniu planu, który najlepiej spełnia potrzeby Twojego zespołu, możesz zaprosić tylu członków zespołu, ilu tylko potrzebujesz, przechodząc do ustawień zarządzania zespołem. Możesz dodawać i usuwać członków ze swojego zespołu w dowolnym momencie, gdy Twoja subskrypcja jest aktywna.',
          answer_5:
            'Akceptujemy płatności PayPal i karty kredytowe głównych marek takich jak Visa, Mastercard i American Express. W niektórych krajach obsługujemy również inne systemy płatności online. <br /><br />\n\nNie akceptujemy bezpośrednich przelewów bankowych, ponieważ musisz dokonać subskrypcji rocznej lub miesięcznej z cyklicznymi płatnościami. (Przed pobraniem pierwszej cyklicznej płatności wyślemy Ci wiadomość e-mail z powiadomieniem).',
          answer_6:
            'Jeśli nie masz nieograniczonego przechowywania plików na koncie WeTransfer Premium, konieczne będzie oczyszczenie miejsca do przechowywania poprzez usunięcie części wysłanych transferów lub ulepszenie konta. Do tego czasu nie można wysyłać nowych transferów. <br /><br />\n\nJeśli używasz WeTransfer bezpłatnie, wszystkie Twoje transfery do 2 GB są automatycznie usuwane po 7 dniach. Bez obaw – nie możesz przekroczyć swojego limitu miejsca do przechowywania.',
          answer_6_variant_asterisk:
            'Musisz zwolnić trochę miejsca do przechowywania, usuwając niektóre z wysłanych transferów lub ulepszając swój plan. Do tego czasu nie możesz wysyłać nowych transferów. <br /><br />\n\nJeśli masz subskrypcję Premium i osiągniesz 5 TB, możesz skontaktować się z naszym zespołem wsparcia i poprosić o dodatkowe miejsce do przechowywania, aż do maksymalnego rocznego limitu wynoszącego 15 TB. <br /><br />\n\nJeśli używasz WeTransfer bezpłatnie, wszystkie Twoje transfery do 2 GB są automatycznie usuwane po 7 dniach. Bez obaw – nie możesz przekroczyć swojego limitu miejsca do przechowywania.',
          answer_6_variant_limited_storage:
            'Musisz zwolnić trochę miejsca do przechowywania, usuwając niektóre z wysłanych transferów lub ulepszając swój plan (chyba że masz subskrypcję Premium). Do tego czasu nie możesz wysyłać nowych transferów. <br /><br />\n\nJeśli używasz WeTransfer bezpłatnie, wszystkie Twoje transfery do 2 GB są automatycznie usuwane po 7 dniach. Bez obaw – nie możesz przekroczyć swojego limitu miejsca do przechowywania.',
          answer_7:
            'Twoja subskrypcja zostanie automatycznie odnowiona (zanim to nastąpi po raz pierwszy, wyślemy Ci wiadomość e-mail), ale możesz zrezygnować w każdej chwili. <br /><br />\n\nAby przejść na korzystanie z bezpłatnej wersji WeTransfer, wystarczy przejść do ustawień swojego <strong>konta</strong> i anulować subskrypcję. Będziesz mieć możliwość (wraz ze wszystkimi członkami Twojego zespołu) korzystania z planu Pro lub Premium do końca obecnego okresu subskrypcji.',
          answer_8:
            'Miliony użytkowników na całym świecie polegają na WeTransfer i naszym zestawie narzędzi do udostępniania swoich pomysłów – co miesiąc wysyłają ponad 2 miliardy plików za pośrednictwem naszej platformy.<br /><br />\n\nAby zabezpieczyć Twoje pomysły przed atakiem lub wykorzystaniem, Twoje pliki są szyfrowane podczas przesyłania (protokołem TLS) oraz podczas przechowywania (protokołem AES-256). Po zapisaniu plików dostęp do nich można uzyskać tylko za pomocą unikatowych linków wysłanych do nadawcy i odbiorcy.',
        },
        questions: {
          question_1: 'Co się stanie po dokonaniu rejestracji i zapłaceniu?',
          question_2: 'Czy odbiorcy moich plików muszą się rejestrować?',
          question_3:
            'Czy mogę otrzymać większe transfery od jakiejkolwiek osoby? ',
          question_4: 'Jak dodać (i usunąć) członków zespołu?',
          question_5: 'Jakie metody płatności są dostępne?',
          question_6: 'Co się stanie, jeśli przekroczę limit miejsca?',
          question_7: 'Jak anulować subskrypcję?',
          question_8:
            'Czy mogę zaufać WeTransfer? Jakie zabezpieczenia są stosowane?',
        },
        title: 'Często zadawane pytania',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Reklamy (i prace artystyczne)',
            custom: 'Prześlij własne pliki',
            feature_1: 'Własna strona WeTransfer',
            feature_2: 'Tapety w tle',
            feature_3: 'Spersonalizowane wiadomości e-mail WeTransfer',
          },
          title: 'Prezentacja swojej marki',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} miejsca',
            title: 'Collect by WeTransfer',
          },
          paste: {
            limited_decks:
              'Do %{pasteDecksLimit} zbiorów z domyślnym logo Paste',
            title: 'Paste® by WeTransfer',
            unlimited_decks: 'Nielimitowane zbiory z własnym brandingiem',
          },
          title: 'Dodatkowe narzędzia do kreatywnej pracy',
        },
        expiry: 'Transfery wygasają po %{days} dniach',
        extra_storage: 'Dodatkowe %{storageLimit} na osobę',
        monthly_price: '%{price} miesięcznie za osobę',
        portals: {
          features: {
            feature_1: 'Portale',
            feature_2: 'Przeglądy',
            feature_3: 'Branding klienta',
          },
          title: 'Udostępnianie prac do oceny i zatwierdzenia',
        },
        security: {
          features: {
            feature_1: 'Niestandardowe terminy wygaśnięcia',
            feature_2: 'Transfery chronione hasłem',
            feature_3: 'Szyfrowanie danych',
            feature_4: 'Uwierzytelnianie dwuskładnikowe',
          },
          title: 'Zabezpieczenie transferów',
        },
        storage_limit: '%{storageLimit} na osobę',
        teams: {
          features: {
            feature_1: 'Możliwość zaproszenie członków zespołu',
            feature_2: 'Wspólny przegląd transferów',
            feature_3: 'Wspólne miejsce',
            feature_4: 'Wspólny branding',
          },
          title: 'Dostarczaj prace jako zespół',
          subtext: {
            text: 'Funkcja dostępna tylko po wykupieniu subskrypcji na naszej stronie internetowej.',
            learn_more: 'Dowiedz się więcej',
          },
        },
        tooltips: {
          tooltip_1:
            'Wszystkie wysyłane przez Ciebie transfery wliczają się do Twojego limitu przechowywania',
          tooltip_10:
            'Możesz bezpiecznie wysyłać i przechowywać pliki z szyfrowaniem TLS i AES-256',
          tooltip_11: 'Monitoruj pobrania i wspólnie zarządzaj transferami',
          tooltip_12:
            'Zaprezentuj swoją pracę (zespołową) dzięki tapetom oraz wiadomościom e-mail z Twoim brandingiem',
          tooltip_13:
            'Paste to narzędzie do tworzenia prezentacji, które pozwala zaprojektować zbiory z dynamicznym motywem kolorystycznym, dopasowaniem i układem',
          tooltip_14:
            'Collect umożliwia zapisywanie i organizowanie zdjęć, filmów, muzyki i linków na różnych urządzeniach',
          tooltip_2:
            'Użytkownicy mogą pobierać Twoje pliki bez logowania i rejestrowania się',
          tooltip_3: 'Śledź, kto pobrał Twoje pliki (lub nie)',
          tooltip_4: 'Uporządkuj swoją pracę według klientów i projektów',
          tooltip_5:
            'Zaproś klientów do wyświetlania i wybierania plików, dodawania komentarzy i zatwierdzania bez konieczności pobierania plików',
          tooltip_6:
            'Dodaj logo i tytuł, aby dostosować swoje portale do każdego z klientów',
          tooltip_7:
            'Twoja strona WeTransfer jest miejscem, w którym użytkownicy mogą pobierać Twoje pliki oraz wysyłać do Ciebie transfery w ramach ograniczenia wielkości Twojego planu',
          tooltip_8:
            'Tapety to filmy i obrazy wyświetlane w tle podczas wysyłania i odbierania plików na wetransfer.com.',
          tooltip_9:
            'Wow! Wydawało nam się, że nikt tego nie czyta – dzięki Tobie wiemy, że byliśmy w błędzie. Gratulacje! Zrzuty ekranu mogą (ale nie muszą) zostać ponownie opublikowane z tagiem @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Limit wielkości transferu',
            feature_2: 'Przechowywanie',
            feature_3: 'Pobieranie bez tworzenia konta',
            feature_4: 'Śledzenie pobrań',
            feature_5: 'Aplikacja dla systemu iOS',
          },
          title: 'Wysyłanie dużych plików',
        },
        unlimited: 'Bez ograniczeń',
        yearly_price: '%{price} rocznie za osobę',
      },
      header: {
        subtitle:
          'WeTransfer sprawi, że Twoje kreatywne projekty nabiorą tempa – bez względu na to, czy wysyłasz duże pliki znajomym, czy też przekazujesz klientom efekty swojej pracy.',
        title: {
          english_1: 'Ty masz pomysły,',
          english_2: 'my mamy plany',
          general: 'Plany i ceny',
        },
      },
      plans: {
        billing: {
          discount: 'Oszczędzasz %{percentage} (nieźle, prawda?)',
          monthly: 'Rozliczenia miesięczne',
          yearly: 'Rozliczenia roczne',
        },
        free: {
          subtitle: 'Do wysyłania plików raz na jakiś czas',
          title: 'Free',
          usp: {
            feature_1: 'Wysyłaj do %{transferLimit}',
            feature_2: 'Nie ma potrzeby weryfikowania transferów',
          },
        },
        premium: {
          subtitle: 'Do nielimitowanego udostępniania pracy',
          title: 'Premium',
          usp: {
            feature_1: 'Brak limitu wielkości transferów',
            feature_2: 'Nieograniczone przechowywanie plików',
            feature_2_subtitle:
              '* Początkowy limit wynosi %{storageLimit}, z możliwością dodania miejsca w razie potrzeby. Obowiązuje maksymalny roczny limit wynoszący %{annualStorageLimit}. Dodatkowe informacje można znaleźć w naszych <a href="/legal/terms" data-route-type="premium" target="_blank">Warunkach korzystania z usługi</a>.',
            feature_3: 'Portale i przegląd bez ograniczeń',
          },
        },
        pro: {
          subtitle: 'Do regularnego wysyłania dużych plików',
          title: 'Pro',
          usp: {
            feature_1: 'Wysyłanie i odbieranie plików do %{transferLimit}',
            feature_2: 'Przechowywanie %{storageLimit} na osobę',
            feature_3: '%{portalsLimit} portal, przeglądy bez ograniczeń',
          },
        },
        tagline: {
          free: 'bez kosztów, bez problemu',
          monthly: 'miesięcznie za osobę',
          yearly: 'rocznie za osobę',
          per_person_monthly: 'za osobę, rozliczane miesięcznie',
          per_person_yearly: 'za osobę, rozliczane rocznie',
          tax_included: 'z podatkiem',
        },
        title: 'Wybierz swój plan',
        month: 'miesiąc',
      },
      skip_link: 'Przejdź do szczegółowych funkcji',
    },
    pro_classic: {
      hero: {
        cta_1: 'Dowiedz się więcej',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Ty masz pomysły, my mamy plan',
      },
      cta: 'Chcę tylko wysłać pliki',
      free_panel: {
        cta: 'Zarejestruj się',
      },
      plan: {
        free: {
          feature_1: 'Wysyłaj do <strong>%{transfer_limit}</strong>',
          feature_2: 'Nie ma potrzeby weryfikowania transferów',
          subtitle_new: 'Dla rzadko wysyłających pliki',
          title: 'Free',
        },
        pro: {
          feature_1: 'Wysyłaj i odbieraj do <strong>%{transfer_limit}</strong>',
          feature_2: 'Decydujesz, kiedy transfery wygasają',
          feature_5: '1 TB miejsca na osobę',
          subtitle_new: 'Dla profesjonalistów i zespołów',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Zarejestruj się teraz',
          descripttion: 'Śledzenie transferów',
          feature_1: 'Wysyłanie do 2 GB',
          feature_2: 'Otrzymuj transfery w ramach jednego przeglądu',
          title: 'Free',
        },
        pro: {
          cta: 'Dowiedz się więcej',
          descripttion: 'Skorzystaj z najlepszych opcji WeTransfer',
          feature_1: 'Wysyłanie i odbieranie plików do %{transfer_size}',
          feature_2: 'Przechowywanie %{storage_size} transferów na osobę',
          feature_3: 'Wysyłaj transfery z niestandardowymi ustawieniami',
          title: 'Pro',
        },
        title:
          'Nie pozwól, aby transfery zaginęły w Twojej skrzynce odbiorczej.',
      },
      title: 'Wykorzystaj w pełni nowe możliwości WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Zaproś swój zespół',
        pagename: 'Zaproś swój zespół',
      },
      manage: {
        cta: 'Zarządzaj zespołem',
      },
      members:
        'Masz %{amountOfMembers} członków zespołu. <a href="%{href}">%{cta}</a>',
      no_members:
        'Na razie nie ma nikogo oprócz Ciebie! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Ustawienia zespołu',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Utwórz zespół, aby wysyłać wspólne transfery',
        context:
          'Wysyłaj i otrzymuj transfery wraz z zespołem, korzystając ze wspólnego miejsca, brandingu oraz wzajemnego dostępu do transferów.',
        invite_team: 'Zaproś swój zespół',
        dismiss: 'Może później',
      },
      feature_highlight: {
        free_context:
          'Teraz możesz zarządzać wysłanymi i odebranymi transferami w jednym, przejrzystym przeglądzie. Otrzymaj powiadomienie natychmiast po pobraniu plików. Wyślij ponownie, przekaż dalej lub pobierz swoje transfery jednym kliknięciem. To tak proste',
        free_subtitle: 'Wszystkie Twoje transfery w jednym miejscu',
        paste_collect_link:
          'Przejdź do <a href="%{pasteUrl}" rel="external">%{pasteName}</a> lub <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Możesz teraz wysyłać transfery bez limitu wielkości oraz utworzyć własną <b>stronę WeTransfer</b>, aby określić, co zobaczą osoby pobierające Twoje pliki. Chcesz teraz skonfigurować swój adres URL i tapety?',
        premium_cta: 'Utwórz stronę',
        premium_dismiss: 'Może później',
        premium_subtitle: 'Skonfiguruj swoją stronę WeTransfer',
        premium_team_context:
          'Możesz teraz wysyłać i odbierać transfery o dowolnej wielkości z <b>niestandardowej strony WeTransfer</b> swojego zespołu.',
        pro_context:
          'Możesz teraz wysyłać do %{transfer_limit} naraz oraz utworzyć własną stronę <b>WeTransfer</b>, którą zobaczą wszystkie osoby pobierające Twoje pliki. Chcesz teraz skonfigurować swój adres URL i tapety?',
        pro_team_context:
          'Możesz teraz wysyłać i odbierać transfery do %{transfer_limit} z <b>niestandardowej strony WeTransfer</b> swojego zespołu.',
        send_cta: 'Przejdź do wysyłania plików',
        team_subtitle: 'Dostarczaj wyniki swojej kreatywnej pracy jako zespół',
      },
      marketing: {
        context:
          'Teraz, gdy już wiemy więcej na Twój temat, z chęcią opowiemy Ci więcej o sobie. Chcesz poznać historie kreatywnych twórców oraz otrzymywać aktualności dotyczące WeTransfer?',
        image_alt_text:
          'Przykładowa treść wiadomości e-mail, która obejmuje nowe funkcje produktów, raporty branżowe oraz artykuły WePresent przedstawiające historie kreatywnych twórców.',
        opt_in: 'Tak, proszę',
        opt_out: 'Nie, dziękuję',
        unsubscribe:
          'Zawsze możesz anulować subskrypcję później – nikt nie będzie miał o to żalu.',
      },
      welcome: {
        context:
          'Poznając Cię nieco lepiej, możemy jeszcze bardziej ulepszyć nasze usługi.',
        cta: 'Kontynuuj',
        dismiss: 'Pomiń',
        dropdown_options: {
          architecture: 'Architektura / budownictwo',
          data: 'Dane / finanse / prawo',
          design: 'Projektowanie / ilustracja',
          education: 'Edukacja / szkolenia',
          marketing: 'Marketing / PR',
          music: 'Muzyka / dźwięk',
          other: 'Coś innego (i bardzo mnie to cieszy)',
          photography: 'Fotografia',
          product: 'Produkt / oprogramowanie',
          sales: 'Sprzedaż / relacje z klientami',
          video: 'Wideo / animacja',
        },
        free_tier_title: 'Witamy w WeTransfer, %{name}!',
        placeholder: 'Zobaczmy...',
        question: 'Po pierwsze – w jakiej branży prowadzisz działalność?',
        team_title: 'Jesteś w zespole, %{name}!',
        tier_title: 'Witamy w WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Zezwól WeTransfer na korzystanie z udostępnianych przez Ciebie danych w celu wyświetlania dopasowanych reklam na naszych stronach internetowych i poza nimi.',
          tooltip_anchor: 'Co to oznacza?',
          tooltip: {
            title: 'W jaki sposób WeTransfer wykorzystuje moje dane?',
            p1: 'Wykorzystujemy Twój adres e-mail, aby wyświetlać Tobie (i innym użytkownikom) reklamy WeTransfer na odwiedzanych przez Ciebie stronach internetowych, w tym w mediach społecznościowych.',
            p2: 'Wykorzystujemy także Twoją dziedzinę zawodową, aby zapewnić Ci lepsze środowisko pracy na naszych stronach internetowych.',
            p3: 'Dane, które zdecydujesz się nam udostępnić, pozostają przez cały czas bezpieczne.',
            button: 'Rozumiem',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Dodaj innych do swojego obszaru roboczego',
      workspace: 'Obszar roboczy',
      manage_workspace: 'Zarządzaj obszarem roboczym',
    },
  },
  exception: {
    activate_subscription_exception:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    complete_payment_exception:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    retrieve_checkout_exception:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    source_id_error:
      'Niestety nie można przetworzyć tego żądania – spróbuj ponownie',
    three_d_secure: 'Obecnie nie obsługujemy kart 3D Secure.',
    something_went_wrong:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    signin_no_data_exception:
      'Wystąpił błąd – sprawdź swoją nazwę użytkownika oraz hasło i spróbuj ponownie',
    signin_exception: 'Niestety logowanie nie powiodło się – spróbuj ponownie',
    signout_exception:
      'Wylogowanie nie powiodło się. To nietypowe. Odśwież stronę, aby zobaczyć, czy nie nastąpiło wylogowanie.',
    signup_account_error:
      'Podczas rejestracji wystąpił błąd – sprawdź swoje dane i spróbuj ponownie',
    retrieve_account_exception:
      'Wystąpił błąd. Głupio nam prosić, ale możesz spróbować ponownie?',
    update_account_error:
      'Niestety nie można zaktualizować danych Twojego konta. Spróbować ponownie?',
    retrieve_subscription_exception:
      'Nie można znaleźć Twoich danych dotyczących płatności – spróbuj ponownie',
    update_subscription_exception:
      'Nie można zaktualizować Twoich danych dotyczących płatności – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    autorenewal_not_supported:
      'Funkcja automatycznego odnawiania nie jest obsługiwana w przypadku tego konta',
    email_background_upload_validation_error:
      'Ten plik jest zbyt duży lub nie jest w formacie png lub jpg – spróbuj wybrać inny obraz',
    email_background_upload_validation_error_videos:
      'Ten plik jest zbyt duży lub nie jest w formacie png lub jpg – spróbuj wybrać inny obraz',
    update_password_exception:
      'Niestety nie można zaktualizować Twojego hasła – spróbuj ponownie',
    retrieve_device_exception:
      'Nie znaleziono żadnych połączonych urządzeń. Ani jednego! Spróbuj ponownie.',
    remove_device_exception: 'Nie można usunąć tego urządzenia',
    renew_subscription_exception:
      'Nie można teraz odnowić Twojego konta – spróbuj ponownie później',
    invoices_retrieve_exception:
      'Nie można znaleźć Twoich potwierdzeń – spróbuj ponownie',
    invoice_download_exception:
      'Nie można pobrać tego potwierdzenia – spróbuj ponownie',
    image_not_valid: 'Wygląda na to, że nie można przesłać tego obrazu',
    update_profile_error:
      'Nie można zaktualizować Twojego profilu – spróbuj ponownie',
    retrieve_profile_exception:
      'Nie można znaleźć ustawień Twojego profilu – spróbuj ponownie',
    s3_exception: 'Podczas przesyłania wystąpił błąd – spróbuj ponownie',
    file_size_limit_reached:
      'Większe nie zawsze oznacza lepsze – prześlij obraz, którego rozmiar nie przekracza 3 MB',
    retrieve_transferlist_exception: 'Nie znaleziono Twojej listy transferów',
    retrieve_transfer_exception: 'Nie znaleziono danych Twojego transferu',
    delete_transfer_exception: 'Nie można usunąć tego transferu',
    delete_transfers_exception: 'Nie można usunąć tych transferów',
    update_expiry_exception: 'Nie można zaktualizować tej daty wygaśnięcia',
    add_contact_exception: 'Nie można dodać tego kontaktu',
    complete_last_order_exception: 'Nie można zrealizować Twojego zamówienia',
    edit_contact_exception: 'Nie można zaktualizować tego kontaktu',
    remove_contact_exception: 'Nie można usunąć tego kontaktu',
    request_password_reset_exception:
      'Niestety nie można przetworzyć tego żądania resetowania – spróbuj ponownie',
    request_password_reset_no_user:
      'Nie rozpoznano tego adresu e-mail – dokładnie sprawdź go i spróbuj ponownie',
    reset_password_error:
      'Podczas resetowania hasła wystąpił błąd – spróbuj ponownie',
    reset_password_exception:
      'Niestety nie można w tej chwili zresetować Twojego hasła – spróbuj ponownie',
    reset_password_token_invalid:
      'Ten link do resetowania nie działa – postępuj zgodnie z instrukcjami podanymi w wiadomości e-mail, którą do Ciebie wysłaliśmy, lub zacznij od początku',
    retrieve_last_order_exception: 'Nie znaleziono Twojego zamówienia',
    retrieve_ternot_exception:
      'Mamy problem z wyszukaniem Twojego transferu – spróbuj ponownie',
    signin_invalid_credentials:
      'Ten adres e-mail i hasło nie są zgodne – dokładnie sprawdź je i spróbuj ponownie',
    unsubscribe_expiration_exception:
      'Podczas anulowania subskrypcji wystąpił błąd – spróbuj ponownie',
    unsubscribe_expiration_invalid_signature:
      'Ten link do anulowania subskrypcji nie działa – spróbuj ponownie',
    cancel_subscription_exception:
      'Wygląda na to, że wystąpił błąd i nie można anulować Twojej subskrypcji. Spróbuj ponownie później.',
    payment_cancelled:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    profile_picture_upload_validation_error:
      'Ten plik jest zbyt duży lub nie jest w formacie png lub jpg – spróbuj wybrać inny obraz',
    reactivate_subscription_exception: 'Wystąpił błąd, spróbuj ponownie',
    retrieve_contactlist_exception: 'Nie znaleziono Twojej listy kontaktów',
    source_retrieve_error:
      'Wystąpił błąd – spróbuj ponownie lub skontaktuj się z nami poprzez nasze <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>',
    token_error: 'Wystąpił błąd. Może spróbować jeszcze raz?',
    update_user_error:
      'Podczas aktualizowania Twoich informacji wystąpił problem',
    wallpaper_upload_validation_error:
      'Ten plik jest zbyt duży lub nie jest w formacie png lub jpg – spróbuj wybrać inny obraz',
    wallpaper_upload_validation_error_videos:
      'Wygląda na to, że Twój film jest niezgodny z naszymi wymaganiami – spróbuj ponownie',
    declined_contact_bank_error:
      'Niestety nie można przetworzyć tej płatności – skontaktuj się z bankiem',
    invalid_password: 'Nie rozpoznano hasła',
    otp_token_invalid: 'Ten kod jest nieprawidłowy lub wygasł',
    projects_load_exception: 'Obecnie nie można załadować Twoich projektów',
    update_information_throttle:
      'Podczas aktualizowania Twoich informacji wystąpił problem. Spróbuj ponownie po odczekaniu %{throttle_time}.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produkty',
        plans_and_pricing: 'Plany i cennik',
        pricing: 'Cennik',
        pro_and_premium: 'WeTransfer Pro i Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Reklama',
        upgrade: 'Ulepsz',
      },
      name_1_2019: 'Firma',
      name: 'Firma',
    },
    home: {
      name: 'Strona główna',
    },
    help: {
      name: 'Pomoc',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transfery',
        contacts: 'Kontakty',
        profile: 'Profile',
        account: 'Konto',
        received: 'Otrzymano',
        sent: 'Wysłano',
        teams: 'Zespół',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Wyloguj się',
    signin: {
      name: 'Zaloguj się',
    },
    branding: 'Branding',
    label: {
      beta: 'Beta',
      new: 'Nowość',
    },
    login: 'Zaloguj się',
    logout: 'Wyloguj się',
    portals: 'Portale',
    signup: 'Zarejestruj się',
    features: {
      name: 'Funkcje',
      all: 'Wszystkie funkcje',
      file_sharing: 'Udostępnianie plików',
      collaboration: 'Współpraca',
      security: 'Bezpieczeństwo danych',
      branding: 'Branding',
      fast_feedback: 'Szybkie informacje zwrotne',
    },
    referral: 'Poleć znajomym',
    switcher: {
      create_free_account: 'Dodaj bezpłatnie',
      just_you: 'Tylko Ty',
      team: 'Zespół',
      team_member_count: 'Członkowie: %{amountOfMembers}',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Nie masz połączenia z internetem',
        begins_space:
          'Nie można wysyłać plików, których nazwy zaczynają się od spacji. Zmień nazwę i spróbuj ponownie.',
        begins_stop:
          'Nie można wysyłać plików, których nazwy zaczynają się od kropki. Zmień nazwę i spróbuj ponownie.',
        blocked:
          'Nie można załadować WeTransfer – wygląda na to, że Cię zablokowano',
        generic: 'Niestety podczas transferu wystąpił błąd',
        has_blackslash:
          'Nie można wysyłać plików, których nazwy zawierają ukośnik odwrotny. Zmień nazwę i spróbuj ponownie.',
        has_linebreak:
          'Nie można wysyłać plików, których nazwy zawierają podział wiersza. Zmień nazwę i spróbuj ponownie.',
        incorrect_recipient:
          'Wygląda na to, że jeden z wprowadzonych adresów e-mail jest nieprawidłowy',
        incorrect_sender:
          'Wygląda na to, że wystąpił problem z Twoim adresem e-mail',
        io_error: 'Wystąpił problem z Twoimi plikami',
        long_filename:
          'Nie można wysyłać plików, których nazwy zawierają więcej niż 250 znaków. Zmień nazwę i spróbuj ponownie.',
        long_message: 'Ta wiadomość jest nieco za długa – skróć ją',
        missing_default_recipient:
          'Tylko zarejestrowane adresy e-mail WeTransfer Pro mogą otrzymywać więcej niż %{free_transfer_limit}. Odśwież stronę, aby rozpocząć od początku.',
        no_clipboard: 'Wygląda na to, że nie skopiowano linku',
        no_files: 'Wygląda na to, że jeszcze nie otrzymano żadnych plików!',
        no_folders: 'Przed wysłaniem należy skompresować folder do pliku zip',
        no_recipient:
          'Potrzebujemy adresu e-mail, na który chcesz wysłać te pliki',
        no_sender: 'Potrzebujemy tylko Twojego adresu e-mai, aby móc rozpocząć',
        too_big:
          'Nie tak prędko – nie można przesyłać transferów większych niż %{upload_limit} naraz',
        too_many_recipient:
          'Nasz limit osób wynosi %{count}. Potrzebujesz więcej? Spróbuj użyć transferu za pomocą linku.',
        unavailable:
          'Niestety ten transfer został usunięty i nie jest już dostępny',
        wrong_password:
          'To hasło jest nieprawidłowe. Spróbuj ponownie lub skontaktuj się z osobą, która wysłała Ci ten transfer.',
        default_title: 'O, nie!',
        duplicate_filename:
          'Nie można wysłać wielu plików o tej samej nazwie. Zmień nazwę i spróbuj ponownie.',
        firstaccept: 'Przed wysłaniem należy zatwierdzić',
        not_downloadable:
          'Podczas pobierania plików wystąpił błąd. Odśwież stronę i spróbuj ponownie.',
        recaptcha: {
          text: 'Wystąpił błąd. Spróbuj ponownie!',
          title: 'O, nie...',
        },
        too_big_text:
          'Możesz wysyłać nie więcej niż %{upload_limit} naraz. Wysyłaj do %{plus_limit} z Pro. ',
        too_big_title: 'Witaj, miłośniku częstego wysyłania',
        too_many_files:
          'Maksymalna liczba plików do wysłania jednocześnie wynosi %{count}',
        too_many_recipient_text:
          'Konto Pro umożliwia wysyłanie transferów do maksymalnie 50 osób.',
        too_many_recipient_title: 'To zbyt wiele osób',
        unavailable_forward:
          'Niestety wygląda na to, że ten transfer został usunięty, więc nie można go przekazać',
        verify: {
          button: 'Proszę o nowy kod!',
          text: 'Spróbuj ponownie lub poproś o nowy kod. ',
          title: 'O, nie!',
        },
      },
      buttons: {
        check_out: 'Sprawdź to!',
        help: 'Centrum pomocy',
        plus: 'Wybierz plan Pro',
        get_link: 'Uzyskaj link',
      },
      tips: {
        change_type:
          'Wyślij link do transferu w wiadomości e-mail lub wygeneruj link, aby udostępnić go w dowolny sposób',
        contacts:
          'Wszystkie osoby, do których wyślesz pliki, zostaną automatycznie dodane do Twojej listy kontaktów',
        expiry:
          'Z WeTransfer Pro to Ty decydujesz o dacie wygaśnięcia transferów. (Możesz nawet zmienić datę wygaśnięcia po ich wysłaniu!).',
        free_limit:
          'Dobra wiadomość – możesz wysłać do %{size} naraz. Lepsza wiadomość – możesz korzystać z usługi tak często, jak tylko chcesz!',
        message: 'Jeśli chcesz, możesz tutaj dodać wiadomość do transferu',
        password:
          'Możesz zabezpieczyć transfer hasłem, aby zwiększyć bezpieczeństwo. Pamiętaj, że hasło nie będzie podane w wiadomości e-mail, więc musisz je przekazać odpowiednim osobom!',
        recipient_limit:
          'Dodaj do %{email_limit} adresów e-mail lub otwórz menu obok przycisku transferu, aby utworzyć link',
        transfer_history:
          'Twój transfer jest przechowywany w przeglądzie transferów',
        your_email:
          'Wpisz tutaj swój adres e-mail, aby umożliwić nam powiadomienie Cię o pobraniu Twoich plików',
        link_transfer:
          'Czy wiesz, że zamiast tego możesz otrzymać link do transferu?',
        previews_receiver:
          'Obrazy wysyłane przez użytkowników Pro można podejrzeć przed pobraniem. Wystarczy kliknąć plik, aby zobaczyć jego zawartość!',
        previews_sender:
          'Wysyłane obrazy można teraz podglądać przed ich pobraniem',
        vrl_text:
          'Można teraz podejrzeć pliki bez konieczności pobierania ich.',
        vrl_title: 'Wyświetl podgląd swoich plików',
        zip_text: 'Wysyłasz folder? Spakujemy go dla Ciebie do formatu .zip',
        zip_title: 'Nie musisz pakować plików do formatu .zip',
        add_display_name_tooltip:
          'Nadaj swojemu transferowi tytuł, aby dać znać, czego dotyczą zawarte w nim pliki. Dzięki temu będzie też łatwiej je później znaleźć.',
        anonymous_sender: {
          button: 'Uzyskaj link',
          text: 'Wpisz swój adres e-mail, aby umożliwić nam powiadomienie Cię o pobraniu Twoich plików.\n\nMusisz zweryfikować adres e-mail, aby potwierdzić swoją tożsamość. Nie chcesz weryfikować go za każdym razem?',
          text_locked_recipient:
            'Wpisz swój adres e-mail, aby umożliwić nam powiadomienie Cię o pobraniu Twoich plików.\n\nMusisz zweryfikować adres e-mail, aby potwierdzić swoją tożsamość.',
        },
        prefer_link: {
          button: 'Uzyskaj link',
          text: 'Nie chcesz weryfikować swojego adresu e-mail? Nie ma problemu.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Dowiedz się więcej',
        previews_sender_learnmore: 'Dowiedz się więcej',
      },
      recipient_locked_text:
        'Ta strona służy do przekazywania plików właścicielowi. Jeśli to Ty, zaloguj się lub przejdź do <a href="https://wetransfer.com">wetransfer.com</a>, aby wysłać pliki do innych osób.',
      recipient_locked_title: 'Uwaga',
      title: {
        previews_receiver: 'Przedstawiamy podgląd obrazów',
        previews_sender: 'Przedstawiamy podgląd obrazów',
      },
    },
    download: {
      blocked: {
        link: 'Dowiedz się więcej',
        text: 'Ten transfer został zgłoszony i nie można go pobrać',
        title: 'Transfer niedostępny',
      },
      title: 'Gotowy dla Ciebie',
      expires: 'Transfer wygaśnie za %{relative_time}',
      expires_never: 'Brak daty wygaśnięcia',
      files: 'Pliki: %{count}, %{size}',
      format: '%{files}・%{expires}',
      expand: 'więcej',
      download_link: 'Link do pobrania',
      files_nosize: {
        one: '%{count} plik',
        other: 'Pliki: %{count}',
      },
      show_all_files_mobile: 'Pokaż wszystkie pliki',
      zip_information:
        'Otrzymasz plik .zip w przypadku pobierania wszystkich plików jednocześnie – <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">więcej informacji</a>',
      files_label: 'Pliki',
      message: 'Wiadomość',
      learn_more: 'dowiedz się więcej',
      expires_in: 'Wygasa za %{expiry}',
      download_all_zip:
        'Wybranie Pobierz wszystko spowoduje pobranie wszystkich plików w formacie .zip',
      back_to_transfer: 'Wróć do transferu',
      cookie_text:
        'Używamy plików cookie, aby zapewnić Ci najlepsze wrażenia. Bez obaw, nie sprzedajemy Twoich danych innym firmom. Zarządzaj swoimi <a href="https://wetransfer.com/legal/manage-cookies" rel="external"></a>preferencjami dotyczącymi danych.',
    },
    preview: {
      open_grid: 'Podgląd',
      click_to_open: 'Kliknij, aby wyświetlić podgląd',
      grid: 'Elementy w tym transferze',
      link: 'Strona internetowa',
      not_previewable: 'Podgląd niedostępny',
      now_open: 'Podgląd otwarty',
      open_link: 'Otwórz link w nowej karcie',
      open_link_short: 'Otwórz link',
      overview: 'przegląd',
      reload: 'Załaduj ponownie',
      something_went_wrong: 'Wystąpił błąd',
      tap_to_open: 'Naciśnij, aby wyświetlić podgląd',
      toobig_copy:
        'Podgląd jest dostępny tylko w przypadku obrazów do 50 MB – <a href="https://wetransfer.zendesk.com/" rel="external">więcej informacji</a>',
      toobig_title: 'Ups, ten obraz jest za duży, aby wyświetlić podgląd',
      unsupported_copy:
        'Zajrzyj do <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">tego artykułu</a>, aby dowiedzieć się, dla jakich plików podgląd jest dostępny',
      unsupported_title: 'Nie można wyświetlić podglądu tego pliku (jeszcze)',
      visit_website: 'Odwiedź stronę internetową',
    },
    complete_mobile: {
      email_text:
        'Wysłano wiadomość e-mail z transferem – Twój transfer jest dostępny przez %{expires}',
      link_text: 'Skopiuj swój link do pobrania:',
      email_text_no_expiry: 'Wysłano wiadomość e-mail do odbiorcy.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Czy wiesz, że 30% naszej powierzchni reklamowej przeznaczone jest na promowanie artystów?</b> Akceptując nasze pliki cookie, zezwalasz nam na zaprezentowanie dzieł sztuki, ważnych spraw, na których nam zależy, a także wyróżnionych nagrodami reklam, które nie przeszkadzają w korzystaniu z serwisu. ',
          text: 'Czy zezwalasz również na pliki cookie naszych zewnętrznych partnerów reklamowych, aby umożliwić personalizację wyświetlanych reklam? ',
          title: 'Nasza kultura dotycząca plików cookie',
        },
        subtitle:
          '<b>To dlatego 30% naszej powierzchni reklamowej przeznaczone jest na promowanie artystów. </b> Akceptując nasze pliki cookie, zezwalasz nam na zaprezentowanie dzieł sztuki, ważnych spraw, na których nam zależy, a także wyróżnionych nagrodami reklam, które nie przeszkadzają w korzystaniu z serwisu. ',
        text: 'Nasza strona internetowa wykorzystuje pliki cookie, które wspierają jej prawidłowe działanie, pozwalają nam lepiej poznać sposób korzystania z WeTransfer, a także pomagają zwiększyć wydajność. Czy zezwalasz również na pliki cookie naszych zewnętrznych partnerów reklamowych, aby umożliwić personalizację wyświetlanych reklam?',
        title: 'Wierzymy, że sztuka może przenosić góry',
        'title-small': 'Witamy w WeTransfer',
      },
      'button-accept': 'Akceptuję',
      'button-accept-all': 'Zaakceptuj wszystko',
      'button-ccpa': 'Rezygnacja ze sprzedaży danych osobowych',
      'button-cookies-privacy': 'Twoje opcje dotyczące prywatności',
      'button-reject': 'Nie, dziękuję',
      'button-save': 'Zapisz',
      'button-save-and-exit': 'Zapisz i zamknij',
      'ccpa-banner-text':
        'Używamy plików cookie, aby zapewnić najlepsze działanie naszej strony internetowej. Bez obaw, nie sprzedajemy Twoich danych innym firmom. Chcesz zrezygnować mimo to? <a href="%{href}">Zarządzaj ustawieniami</a>',
      'ccpa-body':
        'Osoby mieszkające w USA objęte są ochroną na mocy kalifornijskiej ustawy o ochronie prywatności konsumentów (CCPA) oraz mogą zwrócić się do nas z żądaniem zaprzestania sprzedaży ich danych osobowych. Nie oznacza to, że jeśli tego nie zrobią, będziemy wystawiać ich dane osobowe lub prywatne pliki na aukcji – nigdy tego nie robiliśmy i nigdy nie będziemy tego robić! Dokładamy starań, aby Twój cyfrowy ślad był mały i bezpieczny oraz pozostawał pod Twoją kontrolą. Więcej informacji o tym, jakie dane zbieramy i dlaczego, można znaleźć w sekcji <a href="%{href}">Twoje opcje dotyczące prywatności</a>.',
      'ccpa-donotsell': 'Zabraniam sprzedaży moich danych osobowych',
      'ccpa-header': 'Rezygnacja ze sprzedaży danych osobowych',
      'ccpa-intro':
        'Jako odpowiedzialna firma technologiczna, której celem jest, by Internet był jak najlepszym miejscem, nie sprzedajemy Twoich danych innym firmom. Mimo to masz prawo złożyć oficjalną rezygnację w tej kwestii.',
      'ccpa-variant-test-text':
        'Używamy plików cookie, aby zapewnić bezproblemowe korzystanie z naszej strony internetowej oraz aby spersonalizować wyświetlane reklamy. <a href="%{href}">Zarządzaj plikami cookie</a>',
      headline: 'Pliki cookie i reklamy',
      intro:
        'Pieniądze zarobione na naszych estetycznych reklamach są przeznaczane na pokrycie naszych rachunków. Dzięki temu możemy dostarczać naszą usługę udostępniania plików bezpłatnie.',
      'manage-cookies': 'Zarządzaj plikami cookie',
      'partners-consent': 'Zgoda',
      'partners-features': 'Funkcje',
      'partners-headline': 'Nasi partnerzy',
      'partners-text':
        '<p>Oto alfabetyczna lista naszych starannie wybranych partnerów, którym zezwalamy na przeprowadzanie pomiaru Twoich danych, który umożliwia nam śledzenie oraz ulepszanie wydajności.</p>',
      'preferences-headline': 'Zarządzaj plikami cookie ',
      'preferences-text':
        '<p>Szanujemy Twoje prawo do prywatności i możliwości wyboru dotyczące Twoich danych. Musimy przetwarzać niektóre dane osobowe podczas korzystania z naszych narzędzi, ale jesteśmy zobowiązani do odpowiedzialnego i opartego na wartościach podejścia do biznesu, technologii i naszych relacji z użytkownikiem.</p><p>W związku z tym dokładamy starań, aby Twój cyfrowy ślad był mały i bezpieczny oraz pozostawał pod Twoją kontrolą.</p><p>Domyślnie zbieramy i przetwarzamy dane tylko wtedy, gdy jest to bezwzględnie konieczne. Jeśli jednak chcesz wspierać nasze usługi i korzystać z WeTransfer bezpłatnie, prosimy o zezwolenie na udostępnianie informacji naszym partnerom reklamowym.</p>',
      'preferences-text-allow-cookies':
        'Zezwalaj na pliki cookie, aby umożliwić nam i naszym partnerom:<br><br>',
      'purpose-description-first-intro':
        'Aby promować produkty na naszej stronie internetowej i w aplikacjach oraz poza nimi, WeTransfer może: ',
      'purpose-description-first-list':
        '<ul><li>Zbierać informacje o sposobie korzystania przez użytkownika z naszych stron internetowych takie jak kliknięcia i odwiedzane strony, a także (jeśli to możliwe) łączyć te informacje z zapisanymi przez nas danymi na temat użytkownika takimi jak adres e-mail konta </li><li>Korzystać ze zgromadzonych przez nas informacji w celu dostarczania użytkownikowi promocji w wiadomościach e-mail, na naszych stronach internetowych lub w aplikacjach, a także na stronach internetowych i w aplikacjach innych firm. Na przykład możemy promować jeden z naszych innych produktów, gdy użytkownik korzysta z usługi WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'Aby promować produkty na naszej stronie internetowej i w aplikacjach oraz poza nimi, nasi partnerzy mogą: ',
      'purpose-description-second-list':
        '<ul><li>Zbierać informacje o sposobie korzystania przez użytkownika z naszych stron internetowych takie jak kliknięcia i odwiedzane strony, a także (jeśli to możliwe) łączyć te informacje z zapisanymi przez nich danymi na temat użytkownika </li><li>Korzystać ze zgromadzonych przez nich informacji w celu dostarczania użytkownikowi ofert i promocji w wiadomościach e-mail, na ich stronach internetowych lub w aplikacjach, a także na stronach internetowych i w aplikacjach innych firm, z którymi współpracują.</li></ul>',
      'purpose-title':
        'Promowanie produktów na naszej stronie internetowej i w aplikacjach oraz poza nimi',
      'switch-by-partners': 'Przez partnerów',
      'switch-by-we-transfer': 'Przez WeTransfer',
      text: '<p>Nasza strona internetowa wykorzystuje <a href="%{href}">pliki cookie</a>, które wspierają jej funkcjonalność, pozwalają nam analizować sposób korzystania z niej i pomagają zwiększyć wydajność.</p>\n<p>Czy chcesz również zezwolić na pliki cookie od naszych partnerów reklamowych, aby umożliwić personalizację wyświetlanych reklam, a także promowanie produktów WeTransfer oraz naszych partnerów na naszych stronach internetowych i w naszych aplikacjach oraz poza nimi?</p>',
      'text-panel':
        '<p>Nasza strona internetowa wykorzystuje pliki cookie, które wspierają jej funkcjonalność, pozwalają nam analizować sposób korzystania z niej i pomagają zwiększyć wydajność.</p>\n<p>Czy chcesz również zezwolić na pliki cookie od naszych partnerów reklamowych, abyśmy mogli personalizować reklamy, które widzisz, a także promować produkty WeTransfer i naszych partnerów na naszych stronach internetowych i aplikacjach oraz poza nimi?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Najprostszy sposób wysyłania dużych plików oraz odkrywania niesamowitej sztuki i wyróżnionych nagrodami reklam.',
        'cookie-text':
          'Nasza strona internetowa wykorzystuje pliki cookie, które wspierają jej funkcjonalność, pozwalają nam analizować sposób korzystania z niej i pomagają zwiększyć wydajność.\nAkceptując nasze pliki cookie, zezwalasz nam na wyświetlanie spersonalizowanych reklam. Czy słowo „cookie” padło wystarczająco wiele razy? (Cookie).',
      },
      trees: {
        'short-v': {
          subtitle:
            'Postawiliśmy sobie za cel sprawić, by świat stał się piękniejszy, dzięki wyświetlaniu estetycznych reklam wyróżnionych nagrodami, które nie przeszkadzają w korzystaniu z serwisu oraz pomagają nam przyczynić się do odtworzenia lasów namorzynowych.',
          title: 'Nasze pliki cookie pomagają chronić planetę',
        },
        subtitle:
          'Akceptując nasze pliki cookie, bezpośrednio pomagasz nam realizować nasze zobowiązanie wobec środowiska naturalnego. Tylko w tym roku firma WeTransfer zobowiązała się do zasadzenia ponad 175 tysięcy namorzyn – a to dopiero początek. Samo oglądanie naszych wyróżnionych nagrodami reklam sprawi, że przyczynisz się do pozytywnych zmian. ',
        text: 'Nasza strona internetowa wykorzystuje pliki cookie w celu poprawy wydajności, usprawnienia obsługi i lepszego zrozumienia Twoich potrzeb. Akceptując nasze pliki cookie innych firm, zezwalasz nam i naszym partnerom na wyświetlanie bardziej trafnych reklam na naszych stronach internetowych i w naszych aplikacjach oraz poza nimi.',
        title: 'Przesyłaj pomysły. <b>Odmieniaj świat.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Uzyskaj dostęp do aplikacji Collect Pro',
      title: 'Zapisuj i udostępniaj inspiracje, gdziekolwiek jesteś',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Więcej informacji',
      title:
        'Paste® Pro i Collect Pro są teraz uwzględnione w Twojej subskrypcji',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Uzyskaj dostęp do aplikacji Paste® Pro',
      title: 'Przekształć ważne pomysły w efektowne prezentacje',
    },
    terms_conditions: {
      experiment: {
        text: 'Aby kontynuować, zaakceptuj nasze <a href="/legal/terms" data-route-type="plus">Warunki korzystania z usługi</a>.',
        title: "Już <span class='tc-title-exp'>prawie</span> gotowe",
        ustitle:
          "Zapraszamy do najprostszego sposobu <span class='tc-title-exp'>wysyłania dużych plików.</span>",
      },
      title: 'Najpierw...',
      text: 'Aby kontynuować, zaakceptuj nasze <a href="/legal/terms" data-route-type="plus">Warunki korzystania z usługi</a> i <a href="/legal/privacy" data-route-type="plus">Zasady dotyczące plików cookie</a>. Używamy plików cookie w celach funkcjonalnych i analitycznych oraz plików cookie innych firm w celach reklamowych.',
      language: 'Język jest ustawiony na',
      button: 'Zgadzam się',
    },
    upsell_pricing: {
      text: 'Porównaj plany',
      title: 'Chcesz wysyłać większe transfery?',
      receiving: {
        title: 'Chcesz w pełni wykorzystać możliwości WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Wysyłaj i odbieraj transfery do %{transfer_limit} w ramach <strong>jednego wspólnego przeglądu</strong>',
      card2:
        'Dostarczaj wyniki swojej pracy za pomocą <strong>niestandardowej strony WeTransfer swojego zespołu</strong>',
      card3:
        'Współpracuj z innymi użytkownikami za pomocą zbiorów <strong>Paste®</strong> i tablic <strong>Collect</strong>',
      cta: 'Zaczynajmy',
      headline: 'Jesteś w zespole, <strong>%{first_name}!</strong>',
      'opt-in':
        'Chcę poznać historie kreatywnych twórców oraz otrzymywać aktualności dotyczące WeTransfer',
    },
    form: {
      num_files: {
        one: 'Dodano %{count} plik · pozostało %{remaining}',
        other: 'Dodano pliki: %{count} · pozostało %{remaining}',
      },
      add_files: 'Prześlij pliki',
      more_files: 'Dodaj więcej plików',
      available_space: 'Dodaj do %{size}',
      message: 'Wiadomość',
      from: 'Twój adres e-mail',
      to: 'Wiadomość e-mail do',
      other_recipients: {
        one: '+%{count} inna osoba',
        other: '+inne osoby: %{count}',
      },
      reset_forward: 'Odwołaj to przekazanie',
      drop_files: 'lub przeciągnij i upuść',
      files_count: {
        one: 'Dodano %{count} plik · łącznie %{fileSize}',
        other: 'Dodano pliki: %{count} · łącznie %{fileSize}',
      },
      select_folder: 'Lub wybierz folder',
    },
    progress: {
      title: 'Przesyłanie...',
      title_cancel: 'Anulować ten transfer?',
      uploaded: 'Przesłano %{sent} z %{total}',
      remaining: {
        minutes: {
          zero: 'Pozostała mniej niż 1 minuta',
          one: 'Pozostało około 1 minuty',
          other: 'Pozostało około %{count} min',
        },
        hours: {
          one: 'Pozostało około 1 godziny',
          other: 'Pozostało około %{count} godz.',
        },
      },
      document_title: '%{percentage}% – przesyłanie transferu...',
      meta: {
        email: {
          one_file_one_recipient:
            'Wysłanie %{filesCount} pliku do %{recipientsCount} osoby',
          one_file_other_recipients:
            'Wysłanie %{filesCount} pliku do %{recipientsCount} osób',
          other_files_one_recipient:
            'Wysyłanie %{filesCount} plików do %{recipientsCount} osoby',
          other_files_other_recipients:
            'Wysłanie %{filesCount} plików do %{recipientsCount} osób',
        },
        link: {
          one: 'Wysyłanie %{count} pliku',
          other: 'Wysyłanie %{count} plików',
        },
      },
    },
    complete_link: {
      title: 'Gotowe!',
      text: 'Skopiuj link do pobrania lub <a href="/transfer/progress">zobacz, co się w nim znajduje</a>',
      text_copied: 'Skopiowano link do schowka',
      text_manual_copy:
        'Twój link jest gotowy\nNaciśnij %{shortcut}, aby skopiować go do schowka',
      document_title: 'Gotowe!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Twój transfer został przekazany',
    },
    complete_email: {
      title: 'Gotowe!',
      text: 'Wysłano wiadomość e-mail dotyczącą transferu – Twój transfer jest dostępny przez %{expires}. <a href="/transfer/progress">Zobacz, co się w niej znajduje</a>',
      text_no_expiry:
        'Wiadomość e-mail z transferem została wysłana. <a href="/transfer/progress">Zobacz, co się w niej znajduje</a>',
      document_title: 'Wysłano!',
      text_no_details:
        'Wysłano wiadomość e-mail dotyczącą transferu – Twój transfer jest dostępny przez %{expires}.',
      team_discovery_title: 'Transfer wysłany!',
      team_discovery_text:
        'Twój transfer będzie dostępny do pobrania przez %{expires}',
    },
    failed: {
      title: 'Wystąpił błąd',
      text: 'Wygląda na to, że Twój transfer nie działa – spróbuj ponownie',
    },
    pending: {
      title: 'Już prawie gotowe...',
      subtitle: 'Przygotowywanie...',
    },
    downloading: {
      title: 'Pobieranie plików...',
      text: 'Przygotowujemy pobieranie',
    },
    downloaded: {
      title: 'Pobieranie rozpoczęło się',
      text: 'Po zakończeniu pliki będą znajdować się na Twoim komputerze (zwykle w folderze Pobrane).',
      download_links:
        'Pamiętaj, że linki nie będą wyświetlane na tej tablicy – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">więcej informacji</a>.',
    },
    expired: {
      title: 'Transfer wygasł',
      text: 'Niestety ten transfer wygasł i nie jest już dostępny',
    },
    password: {
      title: 'Wprowadź hasło',
      text: 'Hasło jest wymagane do pobrania tego transferu',
    },
    options: {
      transfer_type: 'Wyślij jako',
      password: 'Hasło',
      password_placeholder: 'Ustaw hasło',
      expiry: 'Wygasa po',
      expire_in: {
        '1w': '1 tydzień',
        '2w': '2 tygodnie',
        '1m': '4 tygodnie',
        never: 'Nigdy',
        '14d': '2 tygodnie',
        '28d': '4 tygodnie',
        '365d': '1 rok',
        '7d': '1 tydzień',
        '90d': '3 miesiące',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: 'Wyślij transfer przez e-mail',
      transfer_link: 'Pobierz link do transferu',
    },
    buttons: {
      transfer: 'Wyślij',
      forward: 'Prześlij dalej',
      new_transfer: 'Wysłać plik?',
      cancel: 'Anuluj',
      cancel_no: 'Nie',
      cancel_yes: 'Tak',
      copy_link: 'Kopiuj link',
      ok: 'OK',
      done: 'Wysłać kolejny?',
      team_discovery_done: 'Wyślij nowy transfer',
      retry: 'Spróbuj ponownie',
      continue: 'Kontynuuj',
      download: 'Pobierz',
      download_all: 'Pobierz wszystko',
      back_to_home: 'Wróć do strony głównej',
      cleanup: 'Przegląd transferów ',
      download_all_files: 'Pobierz wszystkie pliki',
      help: 'Centrum pomocy',
      payment: 'Odnów teraz',
      complete_order: 'Przejdź do kasy',
      download_all_experiment: 'Pobierz wszystko w formie pliku .zip',
      download_experiment: 'Pobierz plik',
      download_file: 'Pobierz plik',
      download_zip: 'Pobierz wszystko w formie pliku .zip',
      get_link: 'Pobierz link',
      go_to_transfer: 'Przejdź do transferu',
      openinapp: 'Zapisz za pomocą aplikacji WeTransfer',
      openinapp_experiment: 'Zapisz za pomocą aplikacji WeTransfer',
      openincollectapp: 'Zapisz za pomocą aplikacji Collect',
      get_a_link: 'Uzyskaj link',
    },
    account_expired: {
      text: 'Odnów teraz, aby nadal korzystać ze wszystkich funkcji konta Pro, lub <a href="#signout">wyloguj się</a>, aby korzystać z naszych standardowych usług',
      title: 'Twoje konto Pro wygasło',
    },
    invalid: {
      text: 'Nie można znaleźć Twoich plików',
      title: 'O, nie…',
      link: 'Dowiedz się więcej',
    },
    outdated_browser: {
      text: 'WeTransfer obsługuje całą gamę przeglądarek internetowych, lecz ta wygląda na nieaktualną – zaktualizuj swoją przeglądarkę',
      title: 'Twoja przeglądarka internetowa jest nieaktualna',
    },
    spam: {
      text: 'Ten transfer został zgłoszony jako spam oraz usunięty',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Increase limit',
      limit: 'Up to %{limit} free',
      remaining: '%{remaining} remaining',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Wybierz WeTransfer Pro',
      title: 'Chroń transfery hasłem, aby móc spać spokojnie',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Wybierz WeTransfer Pro',
      title: 'Inteligentniejszy i prostszy sposób zarządzania transferami',
    },
    upsell_one: {
      bubble: {
        button: 'Wybierz plan Pro',
        text: 'Zabezpieczaj swoje transfery hasłem i ustalaj własne daty wygaśnięcia',
        title: 'Ulepszenie transferu?',
        text_experiment:
          'Konto Pro pozwala ustawiać hasła i daty wygaśnięcia transferów.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer na Facebooku',
      title: 'Dołącz do społeczności WeTransfer na Facebooku',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Wybierz WeTransfer Pro',
      title: 'Spersonalizuj swoją stronę WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Wybierz WeTransfer Pro',
      title: 'Więcej, lepiej, mocniej, szybciej',
    },
    account_inactive: {
      text: 'Ukończ rejestrację, aby rozpocząć korzystanie z planu Pro',
      title: 'Twoje konto jeszcze\nnie jest aktywne',
      tiers: {
        text: 'Dokończ płatność, aby zacząć korzystać z planu %{plan}.',
        title: 'Twoja subskrypcja nie jest jeszcze aktywna',
      },
    },
    add_items: {
      files: 'Pliki',
      folders: 'Foldery',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Zobacz, co się w niej znajduje</a>',
    },
    details: {
      button: {
        dismiss: 'Odrzuć',
      },
    },
    download_preview: 'Pobierz plik',
    error: {
      expired: {
        link: 'Skontaktuj się z naszym zespołem wsparcia.',
        text: 'Niestety wygląda na to, że Twój transfer już wygasł.\nCoś nie w porządku?',
        title: 'Transfer wygasł',
      },
    },
    item: {
      details: {
        folder: 'Folder',
      },
    },
    items: {
      zero: 'pusty',
      one: '%{count} element',
      other: 'Elementy: %{count}',
    },
    mobile: {
      button: {
        back: 'Wróć',
        cancel: 'Zacznij od początku',
        next: 'Dalej',
      },
      email: {
        title: 'Dodaj adresy e-mail',
      },
      message: {
        placeholder: 'Dodaj wiadomość do swojego transferu',
        title: 'Wiadomość',
      },
      options: {
        email: 'Wyślij wiadomość e-mail',
        'email-description':
          'Wyślij transfer w prostej wiadomości e-mail, a poinformujemy Cię, gdy zostanie pobrany.',
        link: 'Uzyskaj link',
        'link-description':
          'Przekształć swoje pliki w link, który możesz udostępnić w dowolny sposób.',
      },
    },
    recaptcha: {
      button: 'Jestem człowiekiem',
      text: 'Musimy tylko sprawdzić, czy nie jesteś robotem (bez urazy)',
      title: 'Już prawie gotowe!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Pomóż nam',
      title: 'Możemy zadać Ci kilka pytań na temat Twojego stylu pracy?',
    },
    'verification-code': 'Kod weryfikacyjny',
    verify: {
      button: 'Rozpocznij transfer',
      text: 'Wyszukaj kod weryfikacyjny w skrzynce odbiorczej i wpisz go poniżej',
      title: 'Masz wiadomość e-mail',
      'verification-code': 'Kod weryfikacyjny',
    },
    'account-verification-failed': {
      body: 'Wystąpił problem z potwierdzeniem Twojego adresu e-mail. Wyślij nowy link, aby spróbować ponownie.',
      cta: 'Wysłać nowy link?',
      title: 'Wystąpił błąd',
    },
    'cookie-banner': {
      'button-accept': 'OK',
      'button-decline': 'Nie',
      text: 'Używamy <a href="%{href}">plików cookie</a>, które wspierają funkcjonalność strony internetowej, a także pozwalają nam analizować sposób interakcji z nią i wprowadzać ulepszenia. Czy chcesz zaakceptować także pliki cookie innych firm, aby otrzymywać spersonalizowane reklamy?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Używamy analitycznych plików cookie, aby lepiej poznać sposób korzystania z serwisu WeTransfer. Dzięki nim możemy przeprowadzać testy A/B nowych funkcji, zapewniać sprawne działanie wszystkich funkcji, blokować boty oraz zapobiegać złośliwym działaniom. Te pliki cookie mogą obejmować pliki cookie innych firm, które przetwarzają dane osobowe. ',
        title: 'Analityczne pliki cookie',
      },
      clear: {
        'clear-all-cookies': 'Wyczyść wszystkie pliki cookie',
        description:
          'Możesz usunąć wszystkie swoje dane z naszych plików cookie. W przypadku żądań dotyczących trwałej anonimowości należy <a href="mailto:support@wetransfer.com">skontaktować się z naszym zespołem wsparcia</a>.',
        title: 'Wyczyść pliki cookie',
        warning:
          'Po wyczyszczeniu plików cookie nastąpi wylogowanie z WeTransfer. Nie będzie to miało wpływu na transfery na Twoim koncie.',
      },
      functional: {
        description:
          'Używamy funkcjonalnych plików cookie, aby zapewnić płynne działanie serwisu WeTransfer. Są one wymagane do korzystania z naszej Usługi.',
        title: 'Funkcjonalne pliki cookie',
      },
      'not-yet-set':
        'Wygląda na to, że jeszcze nie określono preferencji dotyczących plików cookie. Zamknij ten panel i ustaw swoje preferencje – zawsze możesz je tutaj zmienić później.',
      'save-and-reload': 'Zapisz ustawienia',
      tracking: {
        description:
          'Nasza Usługa wykorzystuje reklamowe pliki cookie w celu pomiaru efektywności naszych działań handlowych, redakcyjnych i promocyjnych. Reklamowe pliki cookies nie są umieszczane na stronach, które dostarczają informacji o naszej marce oraz produktach. Reklamowe pliki cookie pozwalają nam rejestrować takie zdarzenia jak kliknięcie konkretnej reklamy. Jeśli pliki cookie umieszczone przez inne firmy zostaną rozmieszczone również w innych domenach i na innych stronach internetowych, reklamodawcy mogą mieć możliwość śledzenia zachowania użytkownika w Internecie, jednak WeTransfer nie może uzyskać dostępu do żadnych zebranych danych osobowych ani wykorzystywać ich. W tej kwestii należy zapoznać się z zasadami dotyczącymi prywatności odpowiednich innych firm.',
        title: 'Reklamowe pliki cookie',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Wystąpił błąd',
        'error-email-exists': 'Wygląda na to, że ten e-mail jest już zajęty',
        'throttle-error':
          'Nie tak prędko – wysłano zbyt wiele wiadomości e-mail. Odczekaj %{throttle_time} przed wysłaniem prośby o nowy kod.',
      },
      back: 'Wróć do weryfikacji kodu',
      body: 'Czy to jest poprawne? To jest adres e-mail, którego używasz w WeTransfer.',
      email: 'E-mail',
      error: 'Wystąpił błąd',
      'error-email-exists': 'Wygląda na to, że ten e-mail jest już zajęty',
      submit: 'Wyślij ponownie',
      'throttle-error':
        'Niestety przekroczono dozwoloną liczbę prób. Rozpocznij transfer ponownie.',
      'throttle-error-action': 'Zacznij od początku',
      'throttle-error-link':
        'Nie tak prędko – wysłano zbyt wiele wiadomości e-mail. Odczekaj %{throttle_time} przed wysłaniem prośby o nową wiadomość e-mail.',
      title: 'Sprawdź pocztę e-mail',
    },
    'email-verification-success': {
      body: 'Teraz odbiorcy mają pewność, że transfery naprawdę pochodzą od Ciebie.',
      free_signup: 'Utwórz bezpłatne konto',
      onboarding_body:
        'Doskonale, jesteś na miejscu! Chcesz wybrać własny adres URL i tapety?',
      onboarding_title: 'Witamy na stronie<br/>WeTransfer Pro!',
      send_files: 'Wyślij pliki',
      start_onboarding: 'Zaczynajmy',
      title: 'Twoje konto zostało zweryfikowane!',
      upsell: 'Nie chcesz za każdym razem weryfikować swojego adresu e-mail?',
      verified_sender_tooltip:
        'Twój adres e-mail jest zweryfikowany, dzięki czemu odbiorcy mają pewność, że transfery pochodzą od Ciebie. Aby zmienić ten adres e-mail, zaktualizuj swoje <a href="%{href}">dane osobowe</a>.',
      verified_sender_tooltip_icon:
        'Zweryfikowano adres e-mail. Dzięki temu odbiorcy mają pewność, że transfery pochodzą od Ciebie.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Ten kod jest nieprawidłowy lub wygasł. Kody pozostają aktywne tylko przez %{expiry_time} od wysłania.',
        'error-expiry-time-action': 'Uzyskaj nowy kod',
        'throttle-error':
          'Wpisano błędny lub wygasły kod zbyt wiele razy. Odczekaj %{throttle_time} przed wysłaniem prośby o nowy kod.',
      },
      back: 'Wróć',
      body: 'Wysłaliśmy kod weryfikacyjny na adres <strong title="%{account_email}">%{account_email}</strong>, aby upewnić się, że to naprawdę Ty (pamiętaj, aby sprawdzić folder Spam).',
      body_link:
        'Chcemy tylko szybko sprawdzić, czy to naprawdę Ty.<br /><br />Wysłaliśmy link weryfikacyjny na adres <strong title="%{account_email}">%{account_email}</strong> (jeśli nie możesz go znaleźć, zajrzyj do folderu ze spamem).',
      error: 'Ten kod jest nieprawidłowy lub wygasł',
      'error-expiry-time':
        'Ten kod jest nieprawidłowy lub wygasł. Kody pozostają aktywne tylko przez %{expiry_time} od wysłania.',
      'error-expiry-time-action': 'Uzyskaj nowy kod',
      resend: 'Wiadomość e-mail nie dotarła?',
      submit: 'Weryfikuj',
      'throttle-error':
        'Niestety przekroczono dozwoloną liczbę prób. Rozpocznij transfer ponownie.',
      'throttle-error-action': 'Zacznij od początku',
      title: 'Potwierdź swój e-mail',
      'verification-code': 'Wprowadź kod weryfikacyjny',
    },
    'force-account-verification': {
      body: 'Wyślemy do Ciebie wiadomość e-mail z linkiem do potwierdzenia adresu e-mail, którego używasz w WeTransfer.',
      cta: 'Wyślij wiadomość e-mail',
    },
    'marketing-email-prompt': {
      body: 'Jeszcze jedno – czy chcesz otrzymywać wiadomości o aktualnościach i aktualizacjach produktów WeTransfer?',
      skip: 'Nie, dziękuję',
      subscribe: 'Tak, bądźmy w kontakcie',
      title: 'Weryfikacja ukończona!',
    },
    'terms_conditions-no-cookies': {
      text: 'Aby kontynuować, zaakceptuj nasze <a href="/legal/terms?from_home" data-route-type="plus">Warunki korzystania z usługi</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Pobierz pliki w aplikacji WeTransfer',
      ios_banner_prompt_send: 'Wysyłaj pliki szybko i łatwo',
      tnc_subtitle: 'Najprostszy sposób wysyłania dużych plików',
    },
  },
  account: {
    legend: {
      plan: 'Plan',
      save: 'oszczędzasz %{amount}%',
      subscription: 'Subskrypcja',
      summary: 'Podsumowanie zamówienia',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Dlaczego prosimy o potwierdzenie adresu e-mail',
    workspace: {
      default_workspace: 'Obszar roboczy użytkownika %{name}',
      your_workspace: 'Twój obszar roboczy',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Twoje opcje dotyczące prywatności',
        subtitle: 'Zarządzaj swoimi danymi',
        p1: 'Zawsze chcemy zapewnić Ci najlepsze wrażenia, nawet w kwestii reklam.',
        p2: 'Chcemy wykorzystywać udostępnione przez Ciebie dane takie jak adres e-mail, aby dowiedzieć się, jakie treści lubisz najbardziej, oraz wykorzystać tę wiedzę do wyświetlania Tobie (i innym podobnym użytkownikom) reklam, które są najlepiej dostosowane do Twoich potrzeb.',
        p3: 'Wszystkie treści tworzone i udostępniane w WeTransfer pozostają prywatne – nie czytamy ani nie wykorzystujemy ich do celów reklamowych.',
        p4: 'Te informacje będą zawsze przechowywane bezpiecznie, jeśli zdecydujesz się nam je udostępnić.',
        control_label:
          'Zezwól WeTransfer na korzystanie z udostępnianych przez Ciebie danych takich jak adres e-mail oraz dziedzina zawodowa w celu dopasowania reklam wyświetlanych na naszych stronach internetowych i poza nimi.',
      },
      vertical_nav: {
        terms_of_service: 'Warunki korzystania z usługi',
        privacy_and_cookie_statement:
          'Oświadczenie o ochronie prywatności i plikach cookie',
        your_privacy_choices: 'Twoje opcje dotyczące prywatności',
        notice_and_takedown_policy:
          'Zasady zawiadamiania i usuwania niezgodnych plików',
        responsible_disclosure_policy:
          'Zasady odpowiedzialnego ujawniania informacji',
        advertising_terms_and_conditions:
          'Regulamin dotyczący treści reklamowych',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Zamknij i przejdź do wysyłania plików',
  },
  account_start_screen: {
    'collect-description':
      'Zapisuj wszystkie swoje inspiracje w jednym miejscu – na telefonie, laptopie i tablecie.',
    'collect-title': 'Przejdź do Collect',
    'paste-description':
      'Twórz piękne slajdy w ciągu kilku sekund dzięki zbiorom prezentacji, które projektują się same.',
    'paste-title': 'Przejdź do Paste®',
    title: 'Trzy narzędzia. Jedno konto. Nieskończone możliwości.',
    'transfer-cta': 'Zaczynajmy',
    'transfer-description':
      'Zrób doskonałe wrażenie na wszystkich, którzy pobierają Twoje pliki. Chcesz wybrać własny adres URL i tapety?',
    'transfer-title': 'Skonfiguruj własną stronę WeTransfer',
  },
  account_welcome_screen: {
    'pro-title': 'Witamy w WeTransfer Pro, <strong>%{name}! </strong>',
    accept: 'Tak, proszę',
    'accept-short': 'OK',
    body_1:
      'Chcesz poznać historie kreatywnych twórców oraz otrzymywać aktualności dotyczące WeTransfer?',
    body_2: '(Zawsze możesz anulować subskrypcję później).',
    decline: 'Nie, dziękuję',
    'decline-short': 'Nie, dziękuję',
    title: 'Witamy w WeTransfer, <strong>%{name}</strong>!',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Zaakceptuj pliki cookie',
      deny: 'Odrzuć pliki cookie',
      manage: 'Zarządzaj plikami cookie',
    },
    description:
      'Używamy zwykłych plików cookie i analitycznych plików cookie, aby zapewnić jak najlepsze działanie strony internetowej, a także plików cookie innych firm do celów reklamowych.',
    heading: 'Odkryj najprostszy sposób wysyłania dużych plików',
    snippet: 'Witamy w WeTransfer',
  },
  dropzone: {
    pro: {
      title: "<span>Drop</span> it<br>like it's hot",
    },
    title: 'Drop it like it’s hot',
    text: 'Prześlij pliki lub foldery, upuszczając je w tym oknie',
  },
  form: {
    account: {
      billing_address: 'Adres rozliczeniowy',
      billing_cta: 'Przejdź do płatności',
      billing_title: 'Informacje rozliczeniowe',
      legend: {
        details: 'Twoje informacje rozliczeniowe',
        coupon_code: 'Dodaj kod rabatowy',
        free_plus: 'Uzyskaj bezpłatne konto WeTransfer',
      },
      label: {
        year_label: 'Rocznie',
        year_sublabel: 'Najlepsza oferta: zaoszczędź %{discount_rate}%!',
        month_label: 'Miesięcznie',
        month_sublabel: 'Płatności cykliczne',
        email: 'Adres e-mail',
        not_required: '(opcjonalnie)',
        current_password: 'Aktualne hasło',
        new_password: 'Nowe hasło',
        repeat_new_password: 'Potwierdź nowe hasło',
        password: 'Hasło',
        password_confirm: 'Potwierdź hasło',
        full_name: 'Imię i nazwisko',
        company: 'Firma',
        street_and_number: 'Adres',
        city: 'Miasto',
        zipcode: 'Kod pocztowy',
        country_code: 'Kraj',
        vat_number: 'Podatek VAT',
        coupon_code: 'Kod rabatowy',
        family_name: 'Nazwisko',
        given_name: 'Imię',
        state_code: 'Kraj',
      },
      description: {
        password: 'Wprowadź hasło, które składa się z co najmniej 6 znaków',
        vat_number:
          'Od firm z siedzibą w Holandii pobieramy podatek VAT w wysokości 21%. Jeśli Twoja firma ma siedzibę w innym kraju UE, wprowadź dane swojej firmy oraz europejski numer identyfikacji podatkowej, aby usunąć podatek VAT ze swojego rachunku.\n\nJeśli Twoja firma ma siedzibę poza obszarem UE objętym podatkiem VAT, mimo to będziemy potrzebować Twoich informacji rozliczeniowych, lecz nie naliczymy podatku VAT.',
      },
      error: {
        email: {
          blank: 'Wprowadź swój adres e-mail',
          invalid: 'Wprowadź poprawny adres e-mail',
          taken: 'Ten adres e-mail jest już w użyciu',
          taken_login:
            'Wygląda na to, że masz już konto. <a class="form-notification__message-link" href="%{login_url}">Chcesz się zalogować?</a>',
        },
        current_password: {
          invalid: 'Nie rozpoznano hasła',
          blank: 'Wprowadź aktualne hasło',
        },
        password: {
          blank: 'Wprowadź nowe hasło',
          too_short: 'Twoje hasło musi składać się z co najmniej 6 znaków',
        },
        password_confirm: {
          blank: 'Potwierdź nowe hasło',
          confirm: 'Te hasła nie są zgodne',
        },
        full_name: {
          blank: 'Wprowadź swoje imię i nazwisko',
          too_short:
            'Twoje imię musi składać się z co najmniej 3 znaków (przykro nam, JT)',
        },
        street_and_number: {
          blank: 'Wprowadź swój adres',
        },
        city: {
          blank: 'Wprowadź swoje miasto',
        },
        zipcode: {
          blank: 'Wprowadź swój kod pocztowy',
        },
        country_code: {
          inclusion: 'Sprawdź pisownię lub spróbuj wybrać inny kraj',
          blank: 'Wprowadź swój kraj',
        },
        vat_number: {
          vat_number: 'Wprowadź poprawny numer VAT',
        },
        terms_of_service: {
          accepted:
            'Aby kontynuować, zaakceptuj nasze Warunki korzystania z usługi',
        },
        no_results: 'Sprawdź pisownię lub spróbuj wybrać inny kraj',
        convert: {
          expired:
            'Niestety ten transfer wygasł i nie można go teraz zapisać. Czy wiesz, że subskrypcja WeTransfer Pro umożliwia przechowywanie transferów tak długo, jak tylko chcesz? Dowiedz się więcej tutaj.',
        },
        coupon_code: {
          coupon_code: 'Wprowadź ważny kod rabatowy',
        },
        no_state_results: 'Czy to jest państwo?',
      },
      complete_order: 'Sfinalizuj zamówienie',
      terms_conditions:
        'Akceptuję Warunki korzystania z usługi <a href="/legal/terms" %{options}></a> i potwierdzam zapoznanie się z <a href="/legal/privacy" %{options}>Oświadczeniem o ochronie prywatności i plikach cookie</a>',
      signup_for_plus: 'Utwórz konto WeTransfer Pro',
      account_cta: 'Zaczynajmy',
      signup_for_account: 'Utwórz konto WeTransfer',
      'email-verification-not-verified-link':
        'Zweryfikuj swój adres e-mail. Otwórz wiadomość e-mail, którą do Ciebie wysłaliśmy, lub <button type="button" class="button button--link">poproś o nową</button>.',
      'email-verification-resend': {
        error: 'Wystąpił błąd',
        info: 'Wysłano nowy kod! Sprawdź skrzynkę odbiorczą',
        info_link: 'Wysłano nową wiadomość e-mail! Sprawdź skrzynkę odbiorczą',
        'throttle-error':
          'Nie tak prędko – wysłano zbyt wiele wiadomości e-mail. Odczekaj %{throttle_time} przed wysłaniem prośby o nowy kod.',
      },
      'force-account-verification': {
        message:
          'Zweryfikuj swój adres e-mail, aby potwierdzić swoją tożsamość.',
      },
      marketing_opt_in:
        'Chcę otrzymywać od WeTransfer informacje o nowościach i powiadomienia o aktualizacjach produktów',
      sso: {
        header: 'Dane osobowe',
        password_reset: {
          button: 'Wyślij wiadomość e-mail',
          instructions:
            'Chcesz wprowadzić małą zmianę (hasła)? Nie ma sprawy. Wystarczy nacisnąć poniższy przycisk, aby otrzymać wiadomość e-mail z linkiem do zmiany hasła na adres <span>%{email}</span>.',
          success: 'Wysłano wiadomość e-mail! Sprawdź skrzynkę odbiorczą.',
          title: 'Zmień hasło',
        },
        wrong_user: 'To nie Ty? Wyloguj się',
      },
    },
    payment_cancel: {
      submit: 'Potwierdź',
      client_request:
        'Klient poprosił mnie o korzystanie z WeTransfer, ale już nie potrzebuję tej usługi',
      different_tool: 'Używam teraz innego narzędzia',
      extra_features:
        'Potrzebuję dodatkowych funkcji, których ta usługa nie oferuje',
      not_enough_storage: 'Zbyt mało miejsca do przechowywania jak dla mnie',
      not_often_large_files: 'Nie wysyłam dużych plików aż tak często',
      other: 'Inne',
      other_more: 'Czy możesz powiedzieć nam więcej?',
      skip: 'Pomiń i anuluj subskrypcję',
      temp_project:
        'Wysyłanie dużych plików było mi potrzebne tylko chwilowo do projektu',
      too_expensive: 'Według mnie cena jest zbyt wysoka',
    },
    payment_cancel_reason: {
      skip: 'Nie chcę przekazywać informacji zwrotnej',
    },
    profile: {
      label: {
        profile_title: 'Nazwa',
        wallpaper_link: 'Link do osobistej lub firmowej strony internetowej',
      },
      error: {
        subdomain_name: {
          too_short:
            'Rozumiemy, że „mniej znaczy więcej“, ale Twój adres URL WeTransfer musi składać się z co najmniej 2 znaków',
          domain_name: 'Niestety ktoś już zajął ten adres URL',
          invalid:
            'Bez udziwnień, Twój adres URL WeTransfer może zawierać tylko litery i cyfry (lub łącznik, jeśli jest czymś pomiędzy)',
          taken: 'Niestety ktoś już zajął ten adres URL',
        },
        subdomain: {
          too_short: 'Wprowadź co najmniej dwa znaki',
          too_long: 'Postaraj się zmieścić w limicie 63 znaków',
          invalid:
            'Bez udziwnień, Twój adres URL WeTransfer może zawierać tylko litery i cyfry (lub łącznik, jeśli jest czymś pomiędzy)',
          domain_name: 'Ten adres jest już zajęty',
        },
        default_recipient_email: {
          invalid: 'Wprowadź poprawny adres e-mail',
        },
        wallpaper_link: {
          invalid: 'Wprowadź poprawny adres internetowy',
        },
      },
      success: {
        subdomain: {
          updated: 'Zaktualizowano Twój adres URL',
          available: 'Dobra wiadomość – ten adres URL jest dostępny',
        },
      },
      change_background: 'Prześlij obraz',
      delete_avatar: 'Usuń awatara',
      delete_background: 'Usuń obraz',
      description: {
        title: 'Zmieść się w limicie 150 znaków, aby nic nie zostało ucięte',
        wallpaper_link:
          'Kliknięcie tapety na Twojej stronie spowoduje otwarcie tej strony internetowej w nowej karcie.',
        recipient_email_locked:
          'Pliki wysyłane poprzez Twój profil będą trafiały tylko na ten adres e-mail',
      },
      upload_avatar: 'Prześlij awatara',
      use_email_background_checkbox_label:
        'Użyj tej tapety do wszystkich transferów wysyłanych poprzez mój profil',
      account_email_checkbox: 'Pokaż adres e-mail w profilu',
      default_recipient_email_info:
        'Możesz zmienić ten adres e-mail w swoich <a href="/account">danych osobowych</a>',
      change_subdomain: {
        message:
          'Zmienić adres URL na <a href="%{url}">%{subdomain}.wetransfer.com</a>? Twój poprzedni adres stanie się natychmiast dostępny.',
        confirm: 'Tak, zmień adres URL',
        cancel: 'Wróć',
      },
    },
    fill_in_password: 'Wprowadź hasło, aby zapisać te zmiany',
    select_all: 'Wybierz wszystko',
    deselect_all: 'Odznacz wszystko',
    save_changes: 'Zapisz zmiany',
    save: 'Zapisz',
    submitting: 'Przesyłanie...',
    cancel: 'Anuluj',
    forward: 'Prześlij dalej',
    proceed: 'Kontynuuj',
    delete: 'Usuń',
    onboarding: {
      placeholder: {
        subdomain_name: 'wybierz-dobra-nazwe',
      },
      validated: {
        subdomain_name: 'Dobra wiadomość – ta domena jest dostępna',
      },
    },
    confirm_leave:
      'Czy na pewno chcesz opuścić tę stronę i utracić niezapisane zmiany?',
    unsaved_changes: 'Opuścić stronę? Utracisz wszelkie niezapisane zmiany.',
    contact: {
      add_contact: 'Dodaj kontakt',
      error: {
        email: {
          duplicate: 'Ten adres e-mail jest już na Twojej liście kontaktów',
          invalid: 'Wprowadź poprawny adres e-mail',
        },
      },
      label: {
        company: 'Firma',
        email: 'Adres e-mail',
        name: 'Nazwa',
      },
    },
    error: {
      current_password: {
        blank: 'Wprowadź aktualne hasło',
        invalid: 'Nie rozpoznano hasła',
      },
      email: {
        blank: 'Wprowadź swój adres e-mail',
        duplicate: 'Ten adres e-mail jest już na Twojej liście kontaktów',
        invalid: 'Wprowadź poprawny adres e-mail',
        taken: 'Ten adres e-mail jest już w użyciu',
      },
    },
    leave: 'Wyjdź',
    resetpassword: {
      button: {
        request_submit: 'Wyślij wiadomość e-mail do mnie',
        reset_submit: 'Zapisz nowe hasło',
      },
      label: {
        confirm_new_password: 'Potwierdź nowe hasło',
        email: 'Adres e-mail',
        new_password: 'Nowe hasło',
      },
      legend: {
        request_description:
          'Zablokowany dostęp? Wyślemy Ci instrukcje, które pomogą Ci zresetować hasło i wrócić na dobry tor.',
        request_title: 'Nie pamiętasz hasła?',
        reset_description: 'Wprowadź nowe hasło, aby zalogować się ponownie',
        reset_title: 'Ustaw nowe hasło',
        request_description_success_or_article:
          'Jeśli masz konto WeTransfer, otrzymasz od nas instrukcje dotyczące resetowania hasła. Jeśli nie otrzymasz od nas wiadomości e-mail w ciągu kilku następnych minut, przeczytaj ten <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">artykuł Centrum pomocy</a>.',
      },
    },
    signin: {
      button: {
        submit: 'Zaloguj się',
      },
      label: {
        email: 'Adres e-mail',
        password: 'Hasło',
        remember_me: 'Zapamiętaj mnie',
      },
      link: {
        forgot_password: 'Nie pamiętasz hasła?',
      },
      title: 'Zaloguj się',
    },
    stay_on_page: 'Zostań na stronie',
    close_panel: 'Zamknij',
    go_back: 'Wróć',
    labels: {
      email: 'Adres e-mail',
    },
    plan: {
      change: {
        month: 'Miesięcznie (%{price} %{currency})',
        title: 'Zmień plan',
        year: 'Rocznie (%{price} %{currency})',
      },
      change_plan: 'Zmień plan płatności',
      month: {
        copy: 'Płatności cykliczne',
        label: 'Miesięcznie',
        'label-payment': 'Płatność miesięczna',
        'sub-label': 'Rachunek co miesiąc',
        title: 'WeTransfer Pro: płatność miesięczna',
      },
      title: 'Wybierz najlepsze miejsce do przechowywania swoich pomysłów',
      year: {
        discount: 'Zaoszczędź %{rate} (nieźle, prawda?)',
        'label-payment': 'Płatność roczna',
        'sub-label': 'To aż 17% oszczędności. Super',
        title: 'WeTransfer Pro: płatność roczna',
      },
      your_order: 'Twoje zamówienie',
    },
    save_and_continue: 'Zapisz i kontynuuj',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Wprowadź hasło, aby kontynuować',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Nie teraz',
        true: 'Otwórz w aplikacji WeTransfer',
      },
      headline: 'Może warto pomyśleć o czymś większym?',
      headline2: 'Wyświetlić pliki w aplikacji?',
      subheader: 'Wysyłaj i odbieraj do 200 GB z WeTransfer Pro',
      subheader2:
        'Przeglądaj pliki przed ich pobraniem. Wysyłaj i odbieraj transfery, śledź pobieranie i otrzymuj powiadomienia.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Odnów teraz, aby zachować dostęp do wszystkich korzyści konta %{tier}',
      account_expired_title_tier: 'Twoje konto %{tier} wygasło',
      account_inactive_title_tier: 'Chcesz przejść na %{tier}?',
      account_inactive_action: 'Tak, kontynuuj',
      account_inactive_subtitle:
        'Jeszcze tylko ostatni krok i gotowe. Chcesz zmienić zdanie? Nie ma sprawy –',
      account_inactive_title: 'Chcesz przejść na poziom Pro?',
      account_subscription_action: 'Odnów teraz',
      account_subscription_expired: 'Twoje konto Pro wygasło',
      account_subscription_subtitle:
        'Odnów teraz, aby zachować swoje transfery, osobiste tapety oraz adres internetowy. W przeciwnym razie zostaną wkrótce usunięte!',
      account_expired_action: 'Odnów teraz',
      account_expired_subtitle:
        'Odnów teraz, aby zachować dostęp do wszystkich korzyści konta Pro',
      account_expired_title: 'Twoje konto Pro wygasło',
      expired_transfer_subtitle:
        'Pliki nie są już dostępne. Możesz usunąć informację z przeglądu transferów <a>tutaj</a>.',
      expired_transfer_title: 'Ten transfer wygasł',
      account_email_verify_logged_out:
        'Zaloguj się, aby zweryfikować swój adres e-mail',
      account_inactive_sublink: 'anuluj zamówienie.',
      email_unverified_mobile_cta: 'Gotowe do weryfikacji',
      email_unverified_text:
        "Wysłaliśmy kod weryfikacyjny na adres %{email}. <a href='%{href}'>To nie Ty?</a>",
      email_unverified_text_link:
        "Wysłaliśmy wiadomość na adres %{email}. <a href='%{href}'>To nie Ty?</a>",
      email_unverified_title: 'Zweryfikuj swój adres e-mail',
      'force-account-verification': {
        body: 'Wyślemy do Ciebie wiadomość e-mail z linkiem, aby potwierdzić Twoją tożsamość.',
      },
      'receiving-email':
        'Uwaga! Zastąpiliśmy adres %{receiving_email} w Twoim profilu. Oznacza to, że nowe transfery będą pojawiały się w przeglądzie transferów tylko wtedy, gdy zostały wysłane na adres %{account_email}. Aby to zmienić, możesz w każdej chwili zaktualizować swoje <a href="/account">dane osobowe</a>.',
    },
    design:
      'Jak widać, wprowadziliśmy tutaj kilka zmian! Wiele z nich stanowi odpowiedź na Wasze prośby. Zachęcamy do odkrywania nowej i (nie przechwalając się) ulepszonej strony oraz przesłania nam tutaj wszelkich informacji zwrotnych.',
    loading_error:
      'Wygląda na to, że występuje problem z ładowaniem tej strony.\nBędziemy próbować dalej. Możesz też <a href="%{path}">spróbować odświeżyć to</a> samodzielnie.',
    redesign_notice:
      'Jak widać, <a href="/about/redesign">wprowadziliśmy tutaj kilka zmian</a>! Wiele z nich stanowi odpowiedź na Wasze prośby. Zachęcamy do odkrywania nowej i (nie przechwalając się) ulepszonej strony oraz <a href="/contact" rel="external">przesłania nam tutaj wszelkich informacji zwrotnych<a/>.',
    return_to: 'wróć do %{pageName}',
    close: 'Zamknij panel',
    cookie: {
      accept: 'OK',
      text: 'Używamy plików cookies. Przeczytaj <a href="/legal/terms">informacje prawne</a> (bez przepisów).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Praca',
      press: 'Informacje prasowe',
      terms: 'Warunki',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Ulepsz',
    free_limit:
      'Jednorazowo możesz wysłać maksymalnie 2 GB. Chcesz wysyłać większe transfery?',
    compare_plans: {
      button: 'Porównaj plany',
      text: 'Możesz ulepszyć swój plan, aby przesyłać więcej niż 2 GB naraz.',
      title: 'Masz więcej plików do wysłania?',
    },
    mobile: {
      cta: 'Dowiedz się więcej',
      header: 'Skorzystaj z najlepszych opcji WeTransfer',
      upsell_enjoy: 'Zyskaj więcej miejsca do przechowywania',
      upsell_one: 'Wysyłaj większe transfery',
      upsell_two: 'Spersonalizuj swoją stronę WeTransfer',
    },
    pro_limit:
      'Jednorazowo możesz wysłać maksymalnie 200 GB. Chcesz wysyłać transfery dowolnej wielkości?',
  },
  upsell_tiers_one: {
    text: 'Chcesz ustawiać hasła do swoich transferów oraz ich daty wygaśnięcia?',
  },
  upsell_tiers_three: {
    text: 'Chcesz wysyłać jednocześnie transfery na większą liczbę adresów e-mail niż %{email_limit}?',
    title: 'To o jeden za dużo',
  },
  browser: {
    assets_failed: {
      text: 'Nie można załadować istotnych części naszej strony internetowej.\nMogły zostać zablokowane przez zaporę, serwer proxy lub konfigurację przeglądarki.\nSpróbuj odświeżyć stronę lub skontaktuj się z naszym <a href="https://wetransfer.zendesk.com" rel="external">centrum pomocy</a>.',
      title: 'O, nie...',
    },
    javascript_needed:
      'Potrzebujesz przeglądarki z obsługą JavaScript, aby korzystać z WeTransfer',
  },
  languages: {
    en: 'Angielski',
    nl: 'Holandia',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Ta oferta jest dostępna do %{end_date}. Rabat obowiązuje w pierwszym roku %{user_tier}, po czym subskrypcja odnowi się w pełnej cenie %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount}% zniżki na roczną subskrypcję Pro',
      subtitle: 'Kod rabatowy: %{coupon_code_name}',
      text_content:
        'To wszystko. Taki jest układ. Oferujemy Ci %{discount_amount}% zniżki na roczny plan subskrypcji Pro.',
      argument: {
        size_limit:
          'Wysyłanie i odbieranie transferów plików o wielkości do 200 GB',
        storage_size: '1 TB miejsca',
        unlimited_review: 'Tworzenie nieograniczonej liczby przeglądów',
      },
      cta_label: 'Odbierz zniżkę',
      dismiss_label: 'Nie teraz',
    },
    banner: {
      title:
        'Skorzystaj ze zniżki %{discount_amount}% na WeTransfer Pro na rok – to nasza najlepsza oferta',
      cta_label: 'Ulepsz',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Wysyłaj transfery razem z %{first_recipient_email}',
      subtitle:
        'Zaproś zespół do wysyłania i odbierania transferów w ramach planu %{user_plan}.',
      list: {
        overview_item: 'Wspólny przegląd transferów',
        storage_limit_item: 'Wspólne przechowywanie %{storage_limit} na osobę',
        branding_item: 'Wspólny branding zespołu',
        subscription_item: 'Wspólna subskrypcja i rozliczenia',
      },
      cta: 'Zaproś swój zespół',
      dismiss_button: 'Nie dzisiaj',
    },
    second_viewing: {
      title: 'Zaproś ${first_recipient_email}, aby wspólnie wysyłać transfery',
      subtitle:
        'Zaproś zespół do wysyłania i odbierania transferów w ramach planu %{user_plan}.',
      list: {
        overview_item: 'Wspólny przegląd transferów',
        storage_limit_item: 'Wspólne przechowywanie %{storage_limit} na osobę',
        branding_item: 'Wspólny branding zespołu',
        subscription_item: 'Wspólna subskrypcja i rozliczenia',
      },
      cta: 'Zaproś swój zespół',
      dismiss_button: 'Ukryj na zawsze',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Twoje konto zostało zaktualizowane',
    update_password: 'Twoje hasło zostało zaktualizowane',
    update_subscription: 'Twój plan płatności został zaktualizowany',
    update_profile_success: 'Twój branding został zaktualizowany',
    link_copied: 'Skopiowano ten link do schowka',
    copy_link_manual: 'Wybrano link – skopiuj go, używając skrótu %{shortcut}',
    delete_transfer_success: 'Transfer został usunięty',
    delete_transfers_success: 'Transfery zostały usunięte',
    update_expiry_success: 'Zaktualizowano datę wygaśnięcia',
    onboarding_success:
      'Tędy do przeglądu transferów, kontaktów, brandingu i innych funkcji',
    add_contact_success: 'Ten kontakt został dodany',
    edit_contact_success: 'Ten kontakt został zaktualizowany',
    remove_contact_success: 'Ten kontakt został usunięty',
    already_signed_in: 'Zalogowano',
    cancel_subscription_success:
      'Przykro nam, że odchodzisz – Twoja subskrypcja została anulowana.',
    collect_app_banner_desc:
      'Podglądaj i zapisuj pliki oraz zarządzaj nimi w aplikacji Collect',
    contact_added_confirmation: 'Dodano kontakt do Twojego transferu',
    contact_recipient_locked_text:
      'Ta strona służy do przekazywania plików właścicielowi. Wysyłasz do kogoś innego?',
    forward_ready: 'Twój transfer jest gotowy do przekazania',
    mobile_app_banner_desc:
      'Podglądaj i zapisuj pliki oraz zarządzaj nimi w aplikacji',
    mobile_app_banner_title: 'Zapisz to w aplikacji',
    reactivate_subscription_success:
      'Witamy z powrotem! Twoje konto zostało ponownie aktywowane. ',
    refresh_transfer_upload_lost:
      'Czy na pewno chcesz anulować bieżące przesyłanie?',
    update_payment_success:
      'Twoje dane dotyczące płatności zostały pomyślnie zaktualizowane. Super.',
    update_user: 'Twoje dane zostały zaktualizowane',
    current_team_notification:
      'Używasz planu %{plan} jako zespół %{currentTeam}',
    display_name_updated: 'Tytuł zaktualizowany!',
    download_started:
      'Pobieranie rozpoczęło się. Po zakończeniu pliki będą znajdować się na Twoim komputerze (zwykle w folderze Pobrane).',
    logged_out:
      'Wygląda na to, że wylogowano Cię z innej przeglądarki. Zaloguj się ponownie.',
    project_delete:
      'Usunąć projekt <strong><u>%{projectName}</u></strong> oraz wszystkie dodane do niego pliki?',
    project_delete_success: 'Usunięto projekt <strong>%{projectName}</strong>',
    password_changed: 'Hasło zmienione',
    password_removed: 'Hasło usunięte',
  },
  alert: {
    confirm_cancel_upload_image:
      'Czy na pewno chcesz anulować bieżące przesyłanie? ',
    cancel_recipient_locked: 'Anuluj',
    cancel_refresh_transfer_upload_lost: 'Nie',
    confirm_refresh_transfer_upload_lost: 'Tak',
    go_to_transfer: 'Przejdź do transferu',
    redirect_recipient_locked: 'Tak',
    stay: 'Zostań',
    cancel_project_delete: 'Anuluj',
    confirm_project_delete: 'Usuń',
  },
  force_update:
    'Czekają na nas wspaniałe rzeczy! <a href="/" onClick=\'javascript:window.location.reload();\'>Odśwież przeglądarkę</a>, aby upewnić się, że korzystasz z najnowszej wersji WeTransfer.',
  user: {
    already_logged_in:
      'Już zalogowano – czy na pewno chcesz zresetować swoje hasło?',
    roles: {
      admin: 'administrator',
      owner: 'właściciel',
      user: 'użytkownik',
    },
    sign_out_and_reset: 'Wyloguj się i zresetuj hasło',
  },
  click_here: 'Kliknij tutaj',
  cookiebox: {
    notice:
      '<bold>Jesteś zalogowanym użytkownikiem</bold> – po wyczyszczeniu plików cookie nastąpi wylogowanie. Nie będzie to miało wpływu na Twoje wcześniejsze transfery.',
  },
  notice: {
    general_issues:
      'Coś nie działa prawidłowo? Wiemy, że to frustrujące, ale nie martw się – postaramy się, aby wszystko zaczęło z powrotem działać <a target="_blank" href=%{link}>tak szybko, jak to tylko możliwe</a>',
    transfer_issues:
      'Problem z transferem? Wiemy, że to frustrujące, ale nie martw się – postaramy się, aby wszystko zaczęło z powrotem działać <a target="_blank" href=%{link}>tak szybko, jak to tylko możliwe</a>',
    verification: 'Musimy <a href="/account">potwierdzić Twój adres e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Informacje | WeTransfer',
      advertise: 'Reklamuj się u nas | WeTransfer',
      apps: 'Bezpłatne aplikacje dla systemów Mac iOS i Android | Aplikacje WeTransfer',
      forgot_password: 'Zresetuj hasło | WeTransfer Pro',
      help: 'Jak wysyłać duże pliki | Pomoc WeTransfer',
      home: 'Łatwe i bezpłatne udostępnianie dużych plików | WeTransfer',
      plus: 'Ulepsz swój plan, aby wysyłać większe pliki | WeTransfer Pro',
      sign_in: 'Zaloguj się | WeTransfer',
      sign_up: 'Zarejestruj się | WeTransfer Pro',
      upgrade: 'Ulepsz | WeTransfer Pro',
      pricing:
        'Cennik | WeTransfer – Wysyłaj duże pliki i udostępniaj zdjęcia online – Do 2 GB za darmo',
    },
    descriptions: {
      help: 'Potrzebujesz pomocy technicznej dotyczącej WeTransfer? Odwiedź sekcję Szybka pomoc, aby dowiedzieć się, jak wysyłać duże pliki, lub skontaktuj się z nami.',
      social_help: 'Still haven’t found what you’re looking for?',
    },
  },
  splash: {
    footer: {
      or: 'lub',
      send_files: 'Chcę tylko wysłać pliki',
      no_thanks: 'Nie, dziękuję',
    },
    heading: {
      line_1_free: 'WeTransfer to najlepszy sposób wysyłania dużych plików',
      line_2_free: 'Wykorzystaj w pełni możliwości WeTransfer',
      free_account:
        'Witamy z powrotem. Czy chcesz zostać naszym oficjalnym użytkownikiem?',
    },
    plan: {
      plus: {
        feature_10: 'Dostosuj swoje adresy e-mail',
        feature_11: 'Przechowuj do %{plus_storage_limit}',
        feature_12: 'Decydujesz, kiedy transfery wygasają',
        feature_13: 'Zabezpieczaj swoje transfery hasłem',
        feature_7: 'Spersonalizuj swój profil',
        feature_8: 'Utwórz własną książkę adresową',
        feature_9: 'Dostosuj swój adres URL WeTransfer',
      },
      free_account: {
        cta: 'Zarejestruj się bezpłatnie',
        feature_1: 'Brak miejsca',
        feature_2: 'Wysyłaj do %{free_transfer_limit}',
        feature_3: 'Wysyłaj ponownie i usuwaj transfery',
        heading: 'Konto WeTransfer',
        price_label: 'Zawsze bezpłatnie',
      },
      pro: {
        cta: 'Wybierz WeTransfer Pro',
        feature_1: '%{storage_limit_pro} miejsca',
        feature_2: 'Wysyłanie i odbieranie plików do %{transfer_limit_pro}',
        feature_2_unlimited:
          'Wysyłaj i odbieraj pliki bez ograniczeń wielkości',
        feature_3: 'Wysyłaj ponownie i usuwaj transfery',
        feature_4: 'Zabezpieczaj transfery hasłem',
        feature_5: 'Twoja własna strona Pro i adres URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Dodać: %{recipient} do Twojego zespołu?',
      text_content:
        'Członkowie zespołu mają wzajemny dostęp do swoich transferów, a także wspólne miejsce oraz branding. To nie spowoduje anulowania Twojego transferu.',
      cta: 'Zaczynajmy',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link skopiowany',
      copy: 'Kopiuj link',
      copy_again: 'Skopiuj ponownie',
    },
    labels: {
      share: 'Udostępnij ten transfer',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PORADA',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Wypróbuj portale',
        dismiss: 'Nie teraz',
        text: 'Możesz zaprosić klientów i współpracowników do przeglądania Twoich prac i wybrania ulubionych za pomocą <strong>portali</strong>. Pozwala to ograniczyć liczbę wiadomości e-mail, które wysyłacie do siebie nawzajem.',
        title:
          'Chcesz błyskawicznie uzyskać informacje zwrotne na temat swojej pracy?',
      },
      'second-viewing': {
        cta: 'Wypróbuj portale już teraz',
        dismiss: 'Nie pokazuj tego więcej',
        text: 'Uzyskaj szybkie informacje zwrotne i udostępniaj nowe wersje w jednym miejscu. <strong>Portale</strong> zapewniają sprawny przepływ pracy od przeglądu do poprawki aż po finalne zatwierdzenie.',
        title: 'Praca wysłana. Co teraz?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Przejdź do opcji brandingu',
        text_2: 'Chcesz dodać własne filmy lub obrazy?',
      },
      individual: {
        cta: 'Ustaw stronę',
        text: 'Zrób doskonałe wrażenie za każdym razem na wszystkich, którzy pobierają Twoje pliki, dodając filmy lub obrazy oraz wybierając własny adres URL.',
        title: 'Stwórz własną przestrzeń, konfigurując stronę WeTransfer',
      },
      invitee: {
        cta: 'Rozumiem',
        text_1:
          'Niestandardowa strona zespołu pozwala Ci zrobić doskonałe wrażenie za każdym razem, gdy udostępniasz swoją pracę.',
        text_2:
          'Możesz w dowolnym momencie zmienić tapety swojego zespołu w sekcji <strong>Branding</strong>.',
        title: 'Pochwal się swoją pracą (zespołową)',
      },
      not_now: 'Nie teraz',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Ustaw stronę',
                  premium: {
                    text: 'Każdy może wysyłać do Ciebie transfery o dowolnej wielkości ze strony WeTransfer Twojego zespołu.',
                  },
                  text: 'Każdy może wysyłać do Ciebie transfery do %{transfer_limit_pro} ze strony WeTransfer Twojego zespołu',
                },
                premium: {
                  transfer_link: {
                    text: 'Każdy może wysyłać Ci transfery dowolnej wielkości za pomocą linku: %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Każdy może wysyłać Ci transfery do %{transfer_limit_pro} za pomocą linku: %{custom_link}',
                },
              },
              premium: {
                text: 'Wszyscy mogą wysłać do Ciebie transfery dowolnej wielkości ze strony WeTransfer Twojego zespołu – wystarczy podać im ten link.',
              },
              regular: {
                cta: 'Rozumiem',
                text: 'Każdy może wysłać Ci transfery do <strong>%{transfer_limit_pro}</strong> ze strony WeTransfer Twojego zespołu – wystarczy mieć ten link.',
                title:
                  'Jedno miejsce na wszystkie pliki otrzymane przez Twój zespół',
              },
            },
            sent: {
              regular: {
                cta: 'Rozumiem',
                text: 'Witamy we wspólnym przeglądzie transferów wysłanych przez Twój zespół. Możesz śledzić pobrania, zmieniać daty wygaśnięcia, a nawet edytować lub usuwać transfery innych osób – choć warto je o tym zawczasu poinformować!',
                title: 'Zarządzaj transferami zespołu',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus to teraz WeTransfer Pro z 1 TB miejsca – to 10-krotnie więcej. <a href="/transfers">Sprawdź to.</a>',
  },
  refer_friend: {
    title: 'Poleć znajomym',
    account: {
      description:
        'Przekażemy Tobie i Twojemu znajomemu 10 USD, gdy utworzy konto WeTransfer Pro lub Premium. Udostępnij swój link polecający, aby otrzymać nagrodę w postaci kart przedpłaconych, darowizn na cele charytatywne lub kart podarunkowych kilkuset partnerów.',
    },
    window: {
      link: 'Uzyskaj link polecający',
      send_another: 'Kontynuuj',
      text: 'Przekażemy Tobie i Twojemu znajomemu <strong>10 USD</strong>, gdy utworzy konto WeTransfer Pro lub Premium.',
      title: 'Poleć znajomemu',
      title_2: 'za wysyłanie transferów.',
    },
    message: {
      success:
        'Masz wspaniałych znajomych! Utwórz konto WeTransfer Pro lub Premium, a oboje otrzymacie kartę przedpłaconą, darowiznę na cele charytatywne lub kartę podarunkową o wartości 10 USD.',
      self: 'Ten link polecający nie wygląda prawidłowo. Poproś znajomego o nowy link, aby otrzymać 10 USD po utworzeniu konta WeTransfer Pro lub Premium.',
      fallback:
        'Ten link polecający nie wygląda prawidłowo. Poproś znajomego o nowy link, aby otrzymać 10 USD po utworzeniu konta WeTransfer Pro lub Premium.',
      expired: 'Niestety Twój link polecający wygasł.',
      dismiss: 'Odrzuć',
    },
  },
  order_summary: {
    coupon: {
      link: 'Zastosuj kod promocyjny',
      input_placeholder: 'Kod promocyjny',
      button_label: 'Zastosuj',
      error_message:
        'Niestety ten kod pozwala zaoszczędzić tylko w przypadku subskrypcji: %{billing_period}.',
      generic_error_message: 'Niestety kod jest niezgodny z tą subskrypcją',
      input_error_message: 'To nie jest prawidłowy kod.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Razem',
  },
  mobile_verify: {
    title: 'Wszystko gotowe',
    subtitle:
      'Twój adres e-mail został zweryfikowany – teraz możesz używać aplikacji do wysyłania i odbierania transferów.',
    cta: 'Otwórz w aplikacji WeTransfer',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Twój obecny plan <b>%{formattedintervaltotal}</b> /%{subscriptioninterval} zostanie automatycznie odnowiony <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Your current plan of <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) will automatically renew on <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Your next payment date is <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> /%{interval}',
    team_upgrade_calculation: '(%{membercount} members x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Brak limitów wielkości transferów',
    premium_feature_two: 'Nieograniczone przechowywanie plików',
    premium_feature_three: 'Portale i przegląd bez ograniczeń',
    premium_feature_four:
      'See <a class="all-benefits-link" href="%{all_benefits_href}">all benefits</a>',
    premium_switch_cta_text: 'Switch to premium',
    pill_text: 'Aktualny plan',
    member_count: 'Członkowie: %{membercount}',
    see_all_benefits: 'See all plan benefits',
    pending_downgrade_current_subscription:
      'Twoja subskrypcja obszaru roboczego została anulowana i zakończy się <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Chcesz zmienić zdanie? Bez obaw, możesz z łatwością przywrócić swoje konto.',
    pending_downgrade_reactivate_cta: 'Aktywnuj ponownie subskrypcję',
    pending_downgrade_payment: 'Nie masz żadnych nadchodzących płatności',
    update_payment_cta: 'Aktualizuj dane dotyczące płatności',
    cancel_plan:
      'Jeśli anulujesz subskrypcję, możesz uzyskać dostęp do swojego obszaru roboczego %{planName} do %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Plan Twojego obszaru roboczego zostanie zmieniony na bezpłatny, a istniejące transfery wygasną po 28 dniach.',
    pending_payment_text:
      'To see your plan and payment information, please complete your payment or cancel your order.',
    learn_more: 'Learn more about plans and pricing',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
